window.phoneData = {
      Apple: [
        {
          name: "Ipad Mini 6th Gen",
          url: "https://saleprice.in/collections/apple-ipad-mini-6th-gen-mobile-accessories-collection",
        },
        {
          name: "Iphone 11 Pro",
          url: "https://saleprice.in/collections/apple-iphone-11-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Iphone 12",
          url: "https://saleprice.in/collections/apple-iphone-12-mobile-accessories-collection",
        },
        {
          name: "Iphone 12 Mini",
          url: "https://saleprice.in/collections/apple-iphone-12-mini-mobile-accessories-collection",
        },
        {
          name: "Iphone 12 Pro",
          url: "https://saleprice.in/collections/apple-iphone-12-pro-mobile-accessories-collection",
        },
        {
          name: "Iphone 12 Pro Max",
          url: "https://saleprice.in/collections/apple-iphone-12-pro-max-mobile-accessories-collection",
        },
        {
          name: "Iphone 13",
          url: "https://saleprice.in/collections/apple-iphone-13-mobile-accessories-collection",
        },
        {
          name: "Iphone 13 Mini",
          url: "https://saleprice.in/collections/apple-iphone-13-mini-mobile-accessories-collection",
        },
        {
          name: "Iphone 13 Pro",
          url: "https://saleprice.in/collections/apple-iphone-13-pro-mobile-accessories-collection",
        },
        {
          name: "Iphone 13 Pro Max",
          url: "https://saleprice.in/collections/apple-iphone-13-pro-max-mobile-accessories-collection",
        },
        {
          name: "Iphone 14",
          url: "https://saleprice.in/collections/apple-iphone-14-mobile-accessories-collection",
        },
        {
          name: "Iphone 14 Plus",
          url: "https://saleprice.in/collections/apple-iphone-14-plus-mobile-accessories-collection",
        },
        {
          name: "Iphone 14 Pro",
          url: "https://saleprice.in/collections/apple-iphone-14-pro-accessories",
        },
        {
          name: "Iphone 14 Pro",
          url: "https://saleprice.in/collections/apple-iphone-14-pro-mobile-accessories-collection",
        },
        {
          name: "Iphone 14 Pro Max",
          url: "https://saleprice.in/collections/apple-iphone-14-pro-max-mobile-accessories-collection",
        },
        {
          name: "Iphone 15",
          url: "https://saleprice.in/collections/apple-iphone-15-mobile-accessories-collection",
        },
        {
          name: "Iphone 15 Plus",
          url: "https://saleprice.in/collections/apple-iphone-15-plus-mobile-accessories-collection",
        },
        {
          name: "Iphone 15 Pro",
          url: "https://saleprice.in/collections/apple-iphone-15-pro-mobile-accessories-collection",
        },
        {
          name: "Iphone 15 Pro Max",
          url: "https://saleprice.in/collections/apple-iphone-15-pro-max-mobile-accessories-collection",
        },
        {
          name: "Iphone 16",
          url: "https://saleprice.in/collections/apple-iphone-16-mobile-accessories-collection",
        },
        {
          name: "Iphone 16 Plus",
          url: "https://saleprice.in/collections/apple-iphone-16-plus-mobile-accessories-collection",
        },
        {
          name: "Iphone 16 Pro",
          url: "https://saleprice.in/collections/apple-iphone-16-pro-mobile-accessories-collection",
        },
        {
          name: "Iphone 16 Pro Max",
          url: "https://saleprice.in/collections/apple-iphone-16-pro-max-mobile-accessories-collection",
        },
        {
          name: "Iphone 5",
          url: "https://saleprice.in/collections/apple-iphone-5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Iphone 6",
          url: "https://saleprice.in/collections/apple-iphone-6-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Iphone 6 Plus",
          url: "https://saleprice.in/collections/apple-iphone-6-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Iphone 7",
          url: "https://saleprice.in/collections/apple-iphone-7-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Iphone 7 Plus",
          url: "https://saleprice.in/collections/apple-iphone-7-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Iphone 8",
          url: "https://saleprice.in/collections/apple-iphone-8-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Iphone 8 Plus",
          url: "https://saleprice.in/collections/apple-iphone-8-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Iphone Se 2020",
          url: "https://saleprice.in/collections/apple-iphone-se-2020-mobile-accessories-collection",
        },
        {
          name: "Iphone X",
          url: "https://saleprice.in/collections/apple-iphone-x-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Iphone Xr",
          url: "https://saleprice.in/collections/apple-iphone-xr-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Iphone Xs",
          url: "https://saleprice.in/collections/apple-iphone-xs-mobile-accessories-collection",
        },
        {
          name: "Iphone Xs Max",
          url: "https://saleprice.in/collections/apple-iphone-xs-max-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
      Coolpad: [
        {
          name: "Note 3",
          url: "https://saleprice.in/collections/coolpad-note-3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Note 3 Lite",
          url: "https://saleprice.in/collections/coolpad-note-3-lite-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Note 3 Neo",
          url: "https://saleprice.in/collections/coolpad-note-3-neo-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Note 4",
          url: "https://saleprice.in/collections/coolpad-note-4-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Note 5",
          url: "https://saleprice.in/collections/coolpad-note-5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
      Google: [
        {
          name: "Pixel 10",
          url: "https://saleprice.in/collections/google-pixel-10-mobile-accessories-collection",
        },
        {
          name: "Pixel 10 Pro",
          url: "https://saleprice.in/collections/google-pixel-10-pro-mobile-accessories-collection",
        },
        {
          name: "Pixel 3a",
          url: "https://saleprice.in/collections/google-pixel-3a-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Pixel 4",
          url: "https://saleprice.in/collections/google-pixel-4-mobile-accessories-collection",
        },
        {
          name: "Pixel 4a",
          url: "https://saleprice.in/collections/google-pixel-4a-mobile-accessories-collection",
        },
        {
          name: "Pixel 4a 1",
          url: "https://saleprice.in/collections/google-pixel-4a-mobile-accessories-collection-1",
        },
        {
          name: "Pixel 5",
          url: "https://saleprice.in/collections/google-pixel-5-mobile-accessories-collection",
        },
        {
          name: "Pixel 5a",
          url: "https://saleprice.in/collections/google-pixel-5a-mobile-accessories-collection",
        },
        {
          name: "Pixel 6",
          url: "https://saleprice.in/collections/google-pixel-6-mobile-accessories-collection",
        },
        {
          name: "Pixel 6 Pro",
          url: "https://saleprice.in/collections/google-pixel-6-pro-mobile-accessories-collection",
        },
        {
          name: "Pixel 6a",
          url: "https://saleprice.in/collections/google-pixel-6a-mobile-accessories-collection",
        },
        {
          name: "Pixel 7",
          url: "https://saleprice.in/collections/google-pixel-7-mobile-accessories-collection",
        },
        {
          name: "Pixel 7 Pro",
          url: "https://saleprice.in/collections/google-pixel-7-pro-mobile-accessories-collection",
        },
        {
          name: "Pixel 7a",
          url: "https://saleprice.in/collections/google-pixel-7a-mobile-accessories-collection",
        },
        {
          name: "Pixel 8",
          url: "https://saleprice.in/collections/google-pixel-8-mobile-accessories-collection",
        },
        {
          name: "Pixel 8 Pro",
          url: "https://saleprice.in/collections/google-pixel-8-pro-mobile-accessories-collection",
        },
        {
          name: "Pixel 8a",
          url: "https://saleprice.in/collections/google-pixel-8a-mobile-accessories-collection",
        },
        {
          name: "Pixel 9",
          url: "https://saleprice.in/collections/google-pixel-9-mobile-accessories-collection",
        },
        {
          name: "Pixel 9 Pro",
          url: "https://saleprice.in/collections/google-pixel-9-pro-mobile-accessories-collection",
        },
        {
          name: "Pixel 9a",
          url: "https://saleprice.in/collections/google-pixel-9a-mobile-accessories-collection",
        },
      ],
      Honor: [
        {
          name: "10",
          url: "https://saleprice.in/collections/honor-10-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "10 Lite",
          url: "https://saleprice.in/collections/honor-10-lite-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        { name: "20i", url: "https://saleprice.in/collections/honor-20i" },
        {
          name: "4x",
          url: "https://saleprice.in/collections/honor-4x-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "5c",
          url: "https://saleprice.in/collections/honor-5c-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "6x",
          url: "https://saleprice.in/collections/honor-6x-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "7a",
          url: "https://saleprice.in/collections/honor-7a-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "7c",
          url: "https://saleprice.in/collections/honor-7c-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "7s",
          url: "https://saleprice.in/collections/honor-7s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "7x",
          url: "https://saleprice.in/collections/honor-7x-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "7x",
          url: "https://saleprice.in/collections/honor-7x-mobile-accessories-collection",
        },
        {
          name: "8",
          url: "https://saleprice.in/collections/honor-8-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "8 Lite",
          url: "https://saleprice.in/collections/honor-8-lite-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "8 Pro",
          url: "https://saleprice.in/collections/honor-8-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "8 Smart",
          url: "https://saleprice.in/collections/honor-8-smart-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "8c",
          url: "https://saleprice.in/collections/honor-8c-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "8x",
          url: "https://saleprice.in/collections/honor-8x-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "9 Lite",
          url: "https://saleprice.in/collections/honor-9-lite-mobile-accessories-collection",
        },
        {
          name: "9i",
          url: "https://saleprice.in/collections/honor-9i-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "9n",
          url: "https://saleprice.in/collections/honor-9n-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Holly 2 Plus",
          url: "https://saleprice.in/collections/honor-holly-2-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Mate Pad T8",
          url: "https://saleprice.in/collections/honor-mate-pad-t8-mobile-accessories-collection",
        },
        {
          name: "Mediapad T8",
          url: "https://saleprice.in/collections/honor-mediapad-t8-mobile-accessories-collection",
        },
        {
          name: "Play",
          url: "https://saleprice.in/collections/honor-play-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "View 10",
          url: "https://saleprice.in/collections/honor-view-10-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
      Huawei: [
        {
          name: "Media Pad M5 Lite",
          url: "https://saleprice.in/collections/huawei-media-pad-m5-lite-mobile-accessories-collection",
        },
        {
          name: "Nexus 6p",
          url: "https://saleprice.in/collections/huawei-nexus-6p-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "P20 Lite",
          url: "https://saleprice.in/collections/huawei-p20-lite-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tab M5 Lite",
          url: "https://saleprice.in/collections/huawei-tab-m5-lite-mobile-accessories-collection",
        },
        {
          name: "Y9",
          url: "https://saleprice.in/collections/huawei-y9-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
      Infinix: [
        {
          name: "Gt 10 Pro",
          url: "https://saleprice.in/collections/infinix-gt-10-pro-mobile-accessories-collection",
        },
        {
          name: "Gt 20 Pro",
          url: "https://saleprice.in/collections/infinix-gt-20-pro-mobile-accessories-collection",
        },
        {
          name: "Gt 30 Pro",
          url: "https://saleprice.in/collections/infinix-gt-30-pro-mobile-accessories-collection",
        },
        {
          name: "Hot 10",
          url: "https://saleprice.in/collections/infinix-hot-10-mobile-accessories-collection",
        },
        {
          name: "Hot 10 Play",
          url: "https://saleprice.in/collections/infinix-hot-10-play-mobile-accessories-collection",
        },
        {
          name: "Hot 10s",
          url: "https://saleprice.in/collections/infinix-hot-10s-mobile-accessories-collection",
        },
        {
          name: "Hot 12 Play",
          url: "https://saleprice.in/collections/infinix-hot-12-play-mobile-accessories-collection",
        },
        {
          name: "Hot 20",
          url: "https://saleprice.in/collections/infinix-hot-20-mobile-accessories-collection",
        },
        {
          name: "Hot 30",
          url: "https://saleprice.in/collections/infinix-hot-30-mobile-accessories-collection",
        },
        {
          name: "Hot 30i",
          url: "https://saleprice.in/collections/infinix-hot-30i-mobile-accessories-collection",
        },
        {
          name: "Hot 50",
          url: "https://saleprice.in/collections/infinix-hot-50-mobile-accessories-collection",
        },
        {
          name: "Hot 6 Pro",
          url: "https://saleprice.in/collections/infinix-hot-6-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Hot 60i 4g",
          url: "https://saleprice.in/collections/infinix-hot-60i-4g-mobile-accessories-collection",
        },
        {
          name: "Hot 8",
          url: "https://saleprice.in/collections/infinix-hot-8-mobile-accessories-collection",
        },
        {
          name: "Hot 9 Pro",
          url: "https://saleprice.in/collections/infinix-hot-9-pro-mobile-accessories-collection",
        },
        {
          name: "Hot S3",
          url: "https://saleprice.in/collections/infinix-hot-s3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Hot S3x",
          url: "https://saleprice.in/collections/infinix-hot-s3x-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Note 10 Pro",
          url: "https://saleprice.in/collections/infinix-note-10-pro-mobile-accessories-collection",
        },
        {
          name: "Note 30",
          url: "https://saleprice.in/collections/infinix-note-30-mobile-accessories-collection",
        },
        {
          name: "Note 40 5g",
          url: "https://saleprice.in/collections/infinix-note-40-5g-mobile-accessories-collection",
        },
        {
          name: "Note 40 Pro",
          url: "https://saleprice.in/collections/infinix-note-40-pro-mobile-accessories-collection",
        },
        {
          name: "Note 40x",
          url: "https://saleprice.in/collections/infinix-note-40x-mobile-accessories-collection",
        },
        {
          name: "Note 5",
          url: "https://saleprice.in/collections/infinix-note-5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Note 50x",
          url: "https://saleprice.in/collections/infinix-note-50x-mobile-accessories-collection",
        },
        {
          name: "Smart 2",
          url: "https://saleprice.in/collections/infinix-smart-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Smart 3 Plus",
          url: "https://saleprice.in/collections/infinix-smart-3-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Smart 4 Lite",
          url: "https://saleprice.in/collections/infinix-smart-4-lite-mobile-accessories-collection",
        },
        {
          name: "Smart 5",
          url: "https://saleprice.in/collections/infinix-smart-5-mobile-accessories-collection",
        },
        {
          name: "Smart Hd 2021",
          url: "https://saleprice.in/collections/infinix-smart-hd-2021-mobile-accessories-collection",
        },
        {
          name: "Zero 30",
          url: "https://saleprice.in/collections/infinix-zero-30-mobile-accessories-collection",
        },
        {
          name: "Zero 40",
          url: "https://saleprice.in/collections/infinix-zero-40-mobile-accessories-collection",
        },
      ],
      Iqoo: [
        {
          name: "10 5g",
          url: "https://saleprice.in/collections/iqoo-10-5g-mobile-accessories-collection",
        },
        {
          name: "10 5g 1",
          url: "https://saleprice.in/collections/iqoo-10-5g-mobile-accessories-collection-1",
        },
        {
          name: "11 5g",
          url: "https://saleprice.in/collections/iqoo-11-5g-mobile-accessories-collection",
        },
        {
          name: "12 5g",
          url: "https://saleprice.in/collections/iqoo-12-5g-mobile-accessories-collection",
        },
        {
          name: "13",
          url: "https://saleprice.in/collections/iqoo-13-mobile-accessories-collection",
        },
        {
          name: "6",
          url: "https://saleprice.in/collections/iqoo-6-mobile-accessories-collection",
        },
        {
          name: "7",
          url: "https://saleprice.in/collections/iqoo-7-mobile-accessories-collection",
        },
        {
          name: "8",
          url: "https://saleprice.in/collections/iqoo-8-mobile-accessories-collection",
        },
        {
          name: "9",
          url: "https://saleprice.in/collections/iqoo-9-mobile-accessories-collection",
        },
        {
          name: "9 Se",
          url: "https://saleprice.in/collections/iqoo-9-se-mobile-accessories-collection",
        },
        {
          name: "9t 5g",
          url: "https://saleprice.in/collections/iqoo-9t-5g-mobile-accessories-collection",
        },
        {
          name: "Neo 10",
          url: "https://saleprice.in/collections/iqoo-neo-10-mobile-accessories-collection",
        },
        {
          name: "Neo 7",
          url: "https://saleprice.in/collections/iqoo-neo-7-mobile-accessories-collection",
        },
        {
          name: "Neo 7 Pro 5g",
          url: "https://saleprice.in/collections/iqoo-neo-7-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Neo 9 Pro",
          url: "https://saleprice.in/collections/iqoo-neo-9-pro-mobile-accessories-collection",
        },
        {
          name: "Neo5",
          url: "https://saleprice.in/collections/iqoo-neo5-mobile-accessories-collection",
        },
        {
          name: "Z10 Lite",
          url: "https://saleprice.in/collections/iqoo-z10-lite-mobile-accessories-collection",
        },
        {
          name: "Z10x",
          url: "https://saleprice.in/collections/iqoo-z10x-mobile-accessories-collection",
        },
        {
          name: "Z3",
          url: "https://saleprice.in/collections/iqoo-z3-mobile-accessories-collection",
        },
        {
          name: "Z5",
          url: "https://saleprice.in/collections/iqoo-z5-mobile-accessories-collection",
        },
        {
          name: "Z6",
          url: "https://saleprice.in/collections/iqoo-z6-mobile-accessories-collection",
        },
        {
          name: "Z6 44w",
          url: "https://saleprice.in/collections/iqoo-z6-44w-mobile-accessories-collection",
        },
        {
          name: "Z6 Lite",
          url: "https://saleprice.in/collections/iqoo-z6-lite-mobile-accessories-collection",
        },
        {
          name: "Z6 Pro 5g",
          url: "https://saleprice.in/collections/iqoo-z6-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Z7 5g",
          url: "https://saleprice.in/collections/iqoo-z7-5g-mobile-accessories-collection",
        },
        {
          name: "Z7pro",
          url: "https://saleprice.in/collections/iqoo-z7pro-mobile-accessories-collection",
        },
        {
          name: "Z7s 5g",
          url: "https://saleprice.in/collections/iqoo-z7s-5g-mobile-accessories-collection",
        },
        {
          name: "Z9 Lite",
          url: "https://saleprice.in/collections/iqoo-z9-lite-mobile-accessories-collection",
        },
        {
          name: "Z9 Lite 1",
          url: "https://saleprice.in/collections/iqoo-z9-lite-mobile-accessories-collection-1",
        },
        {
          name: "Z9s Pro",
          url: "https://saleprice.in/collections/iqoo-z9s-pro-mobile-accessories-collection",
        },
        {
          name: "Z9x",
          url: "https://saleprice.in/collections/iqoo-z9x-mobile-accessories-collection",
        },
      ],
      Itel: [
        {
          name: "A23 Pro",
          url: "https://saleprice.in/collections/itel-a23-pro-mobile-accessories-collection",
        },
        {
          name: "A27",
          url: "https://saleprice.in/collections/itel-a27-mobile-accessories-collection",
        },
        {
          name: "A27 1",
          url: "https://saleprice.in/collections/itel-a27-mobile-accessories-collection-1",
        },
        {
          name: "A49",
          url: "https://saleprice.in/collections/itel-a49-mobile-accessories-collection",
        },
        {
          name: "A50c",
          url: "https://saleprice.in/collections/itel-a50c-mobile-accessories-collection",
        },
        {
          name: "A60",
          url: "https://saleprice.in/collections/itel-a60-mobile-accessories-collection",
        },
        {
          name: "A80",
          url: "https://saleprice.in/collections/itel-a80-mobile-accessories-collection",
        },
        {
          name: "A90",
          url: "https://saleprice.in/collections/itel-a90-mobile-accessories-collection",
        },
        { name: "P40", url: "https://saleprice.in/collections/itel-p40" },
      ],
      Lenovo: [
        {
          name: "A5",
          url: "https://saleprice.in/collections/lenovo-a5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A6000",
          url: "https://saleprice.in/collections/lenovo-a6000-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A6000 Plus",
          url: "https://saleprice.in/collections/lenovo-a6000-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A7000",
          url: "https://saleprice.in/collections/lenovo-a7000-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A7700",
          url: "https://saleprice.in/collections/lenovo-a7700-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "K3 Note",
          url: "https://saleprice.in/collections/lenovo-k3-note-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "K4 Note",
          url: "https://saleprice.in/collections/lenovo-k4-note-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "K4 Note",
          url: "https://saleprice.in/collections/lenovo-k4-note-mobile-accessories-collection",
        },
        {
          name: "K5 Note",
          url: "https://saleprice.in/collections/lenovo-k5-note-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "K5 Plus",
          url: "https://saleprice.in/collections/lenovo-k5-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "K6 Note",
          url: "https://saleprice.in/collections/lenovo-k6-note-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "K6 Power",
          url: "https://saleprice.in/collections/lenovo-k6-power-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "K8",
          url: "https://saleprice.in/collections/lenovo-k8-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "K8 Note",
          url: "https://saleprice.in/collections/lenovo-k8-note-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "K8 Plus",
          url: "https://saleprice.in/collections/lenovo-k8-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "K9",
          url: "https://saleprice.in/collections/lenovo-k9-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "P1m",
          url: "https://saleprice.in/collections/lenovo-p1m-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "P2",
          url: "https://saleprice.in/collections/lenovo-p2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "P780",
          url: "https://saleprice.in/collections/lenovo-p780-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Phab 2",
          url: "https://saleprice.in/collections/lenovo-phab-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Phab 2 Plus",
          url: "https://saleprice.in/collections/lenovo-phab-2-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Phab 2 Plus",
          url: "https://saleprice.in/collections/lenovo-phab-2-plus-mobile-accessories-collection",
        },
        {
          name: "Phab 750",
          url: "https://saleprice.in/collections/lenovo-phab-750-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "S850",
          url: "https://saleprice.in/collections/lenovo-s850-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tab 2 A730",
          url: "https://saleprice.in/collections/lenovo-tab-2-a730-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tab 3 710i",
          url: "https://saleprice.in/collections/lenovo-tab-3-710i-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tab 3 730x",
          url: "https://saleprice.in/collections/lenovo-tab-3-730x-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tab 4 10",
          url: "https://saleprice.in/collections/lenovo-tab-4-10-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tab 4 8504",
          url: "https://saleprice.in/collections/lenovo-tab-4-8504-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tab 7 7304f",
          url: "https://saleprice.in/collections/lenovo-tab-7-7304f-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tab 7 7504x",
          url: "https://saleprice.in/collections/lenovo-tab-7-7504x-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tab 7 7504x Tablet",
          url: "https://saleprice.in/collections/lenovo-tab-7-7504x-tablet-accessories-collection",
        },
        {
          name: "Tab 7 7504x Tablet 1",
          url: "https://saleprice.in/collections/lenovo-tab-7-7504x-tablet-accessories-collection-1",
        },
        {
          name: "Tab K10",
          url: "https://saleprice.in/collections/lenovo-tab-k10-mobile-accessories-collection",
        },
        {
          name: "Tab M10",
          url: "https://saleprice.in/collections/lenovo-tab-m10-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tab M10 Hd 10 1 X505",
          url: "https://saleprice.in/collections/lenovo-tab-m10-hd-10-1-x505-mobile-accessories-collection",
        },
        {
          name: "Tab M10 Hd 10 1 X605",
          url: "https://saleprice.in/collections/lenovo-tab-m10-hd-10-1-x605-mobile-accessories-collection",
        },
        {
          name: "Tab M8 Fhd 2nd Gen 8705f",
          url: "https://saleprice.in/collections/lenovo-tab-m8-fhd-2nd-gen-8705f-mobile-accessories-collection",
        },
        {
          name: "Tab V7 4g Wifi",
          url: "https://saleprice.in/collections/lenovo-tab-v7-4g-wifi-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tab V7 4g Wifi 1",
          url: "https://saleprice.in/collections/lenovo-tab-v7-4g-wifi-mobile-accessories-collection-1",
        },
        {
          name: "Vibe C",
          url: "https://saleprice.in/collections/lenovo-vibe-c-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Vibe S1",
          url: "https://saleprice.in/collections/lenovo-vibe-s1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Vibe X2",
          url: "https://saleprice.in/collections/lenovo-vibe-x2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Vibe X3",
          url: "https://saleprice.in/collections/lenovo-vibe-x3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Zuk Z1",
          url: "https://saleprice.in/collections/lenovo-zuk-z1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
      Lyf: [
        {
          name: "Earth 1",
          url: "https://saleprice.in/collections/lyf-earth-1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Earth 2",
          url: "https://saleprice.in/collections/lyf-earth-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Flame 1",
          url: "https://saleprice.in/collections/lyf-flame-1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Flame 6",
          url: "https://saleprice.in/collections/lyf-flame-6-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Flame 8",
          url: "https://saleprice.in/collections/lyf-flame-8-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Water 1",
          url: "https://saleprice.in/collections/lyf-water-1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Water 10",
          url: "https://saleprice.in/collections/lyf-water-10-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Water 2",
          url: "https://saleprice.in/collections/lyf-water-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Water 4",
          url: "https://saleprice.in/collections/lyf-water-4-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Water 6",
          url: "https://saleprice.in/collections/lyf-water-6-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Water 7",
          url: "https://saleprice.in/collections/lyf-water-7-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Wind 1",
          url: "https://saleprice.in/collections/lyf-wind-1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Wind 2",
          url: "https://saleprice.in/collections/lyf-wind-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Wind 4",
          url: "https://saleprice.in/collections/lyf-wind-4-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Wind 6",
          url: "https://saleprice.in/collections/lyf-wind-6-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Wind 7",
          url: "https://saleprice.in/collections/lyf-wind-7-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
      Mi: [
        {
          name: "",
          url: "https://saleprice.in/collections/mi-mobile-accessories",
        },
        {
          name: "10i",
          url: "https://saleprice.in/collections/mi-10i-mobile-accessories-collection",
        },
        {
          name: "11 Lite",
          url: "https://saleprice.in/collections/mi-11-lite-mobile-accessories-collection",
        },
        {
          name: "11 Lite 11 Lite Ne",
          url: "https://saleprice.in/collections/mi-11-lite-11-lite-ne-mobile-accessories-collection",
        },
        {
          name: "11 Lite Ne",
          url: "https://saleprice.in/collections/mi-11-lite-ne-mobile-accessories-collection",
        },
        {
          name: "11i",
          url: "https://saleprice.in/collections/mi-11i-mobile-accessories-collection",
        },
        {
          name: "11x",
          url: "https://saleprice.in/collections/mi-11x-mobile-accessories-collection",
        },
        {
          name: "11x Pro",
          url: "https://saleprice.in/collections/mi-11x-pro-mobile-accessories-collection",
        },
        {
          name: "4i",
          url: "https://saleprice.in/collections/mi-4i-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "5",
          url: "https://saleprice.in/collections/mi-5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A1",
          url: "https://saleprice.in/collections/mi-a1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A2",
          url: "https://saleprice.in/collections/mi-a2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A2 1",
          url: "https://saleprice.in/collections/mi-a2-back-cover-tempered-glass-and-other-mobile-accessories-collection-1",
        },
        {
          name: "A3",
          url: "https://saleprice.in/collections/mi-a3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Max",
          url: "https://saleprice.in/collections/mi-max-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Max 2",
          url: "https://saleprice.in/collections/mi-max-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Note",
          url: "https://saleprice.in/collections/mi-note-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Poco C3",
          url: "https://saleprice.in/collections/mi-poco-c3-mobile-accessories-collection",
        },
        {
          name: "Poco C31",
          url: "https://saleprice.in/collections/mi-poco-c31-mobile-accessories-collection",
        },
        {
          name: "Poco C40 1",
          url: "https://saleprice.in/collections/mi-poco-c40-mobile-accessories-collection-1",
        },
        {
          name: "Poco C50",
          url: "https://saleprice.in/collections/mi-poco-c50-mobile-accessories-collection",
        },
        {
          name: "Poco C51",
          url: "https://saleprice.in/collections/mi-poco-c51-mobile-accessories-collection",
        },
        {
          name: "Poco C55",
          url: "https://saleprice.in/collections/mi-poco-c55-mobile-accessories-collection",
        },
        {
          name: "Poco C61",
          url: "https://saleprice.in/collections/mi-poco-c61-mobile-accessories-collection",
        },
        {
          name: "Poco C65 4g",
          url: "https://saleprice.in/collections/mi-poco-c65-4g-mobile-accessories-collection",
        },
        {
          name: "Poco C71",
          url: "https://saleprice.in/collections/mi-poco-c71-mobile-accessories-collection",
        },
        {
          name: "Poco F1",
          url: "https://saleprice.in/collections/mi-poco-f1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Poco F1",
          url: "https://saleprice.in/collections/mi-poco-f1-mobile-accessories-collection",
        },
        {
          name: "Poco F3",
          url: "https://saleprice.in/collections/mi-poco-f3-mobile-accessories-collection",
        },
        {
          name: "Poco F3 Gt",
          url: "https://saleprice.in/collections/mi-poco-f3-gt-mobile-accessories-collection",
        },
        {
          name: "Poco F4",
          url: "https://saleprice.in/collections/mi-poco-f4-mobile-accessories-collection",
        },
        {
          name: "Poco F5",
          url: "https://saleprice.in/collections/mi-poco-f5-mobile-accessories-collection",
        },
        {
          name: "Poco F6",
          url: "https://saleprice.in/collections/mi-poco-f6-mobile-accessories-collection",
        },
        {
          name: "Poco F7",
          url: "https://saleprice.in/collections/mi-poco-f7-mobile-accessories-collection",
        },
        {
          name: "Poco M2",
          url: "https://saleprice.in/collections/mi-poco-m2-mobile-accessories-collection",
        },
        {
          name: "Poco M2 Pro",
          url: "https://saleprice.in/collections/mi-poco-m2-pro-mobile-accessories-collection",
        },
        {
          name: "Poco M3",
          url: "https://saleprice.in/collections/mi-poco-m3-mobile-accessories-collection",
        },
        {
          name: "Poco M3 1",
          url: "https://saleprice.in/collections/mi-poco-m3-mobile-accessories-collection-1",
        },
        {
          name: "Poco M3 Pro",
          url: "https://saleprice.in/collections/mi-poco-m3-pro-mobile-accessories-collection",
        },
        {
          name: "Poco M3 Pro 5g",
          url: "https://saleprice.in/collections/mi-poco-m3-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Poco M4 5g",
          url: "https://saleprice.in/collections/mi-poco-m4-5g-mobile-accessories-collection",
        },
        {
          name: "Poco M4 Pro 4g",
          url: "https://saleprice.in/collections/mi-poco-m4-pro-4g-mobile-accessories-collection",
        },
        {
          name: "Poco M4 Pro 5g",
          url: "https://saleprice.in/collections/mi-poco-m4-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Poco M5 4g",
          url: "https://saleprice.in/collections/mi-poco-m5-4g-mobile-accessories-collection",
        },
        {
          name: "Poco M5 4g Poco M4 5g",
          url: "https://saleprice.in/collections/mi-poco-m5-4g-poco-m4-5g-mobile-accessories-collection",
        },
        {
          name: "Poco M6 Pro",
          url: "https://saleprice.in/collections/mi-poco-m6-pro-mobile-accessories-collection",
        },
        {
          name: "Poco M6 Pro 4g",
          url: "https://saleprice.in/collections/mi-poco-m6-pro-4g-mobile-accessories-collection",
        },
        {
          name: "Poco M6 Pro 5g",
          url: "https://saleprice.in/collections/mi-poco-m6-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Poco M7",
          url: "https://saleprice.in/collections/mi-poco-m7-mobile-accessories-collection",
        },
        {
          name: "Poco X2",
          url: "https://saleprice.in/collections/mi-poco-x2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Poco X2",
          url: "https://saleprice.in/collections/mi-poco-x2-mobile-accessories-collection",
        },
        {
          name: "Poco X3",
          url: "https://saleprice.in/collections/mi-poco-x3-mobile-accessories-collection",
        },
        {
          name: "Poco X3 Pro",
          url: "https://saleprice.in/collections/mi-poco-x3-pro-mobile-accessories-collection",
        },
        {
          name: "Poco X4 Pro",
          url: "https://saleprice.in/collections/mi-poco-x4-pro-mobile-accessories-collection",
        },
        {
          name: "Poco X5 5g",
          url: "https://saleprice.in/collections/mi-poco-x5-5g-mobile-accessories-collection",
        },
        {
          name: "Poco X5 Pro",
          url: "https://saleprice.in/collections/mi-poco-x5-pro-mobile-accessories-collection",
        },
        {
          name: "Poco X6 Neo",
          url: "https://saleprice.in/collections/mi-poco-x6-neo-mobile-accessories-collection",
        },
        {
          name: "Poco X6 Pro",
          url: "https://saleprice.in/collections/mi-poco-x6-pro-mobile-accessories-collection",
        },
        {
          name: "Poco X7",
          url: "https://saleprice.in/collections/mi-poco-x7-mobile-accessories-collection",
        },
        {
          name: "Poco X7 Pro",
          url: "https://saleprice.in/collections/mi-poco-x7-pro-mobile-accessories-collection",
        },
        {
          name: "Red10",
          url: "https://saleprice.in/collections/mi-redmi-10-mobile-accessories-collection",
        },
        {
          name: "Red10 Power",
          url: "https://saleprice.in/collections/mi-redmi-10-power-mobile-accessories-collection",
        },
        {
          name: "Red10 Prime",
          url: "https://saleprice.in/collections/mi-redmi-10-prime-mobile-accessories-collection",
        },
        {
          name: "Red10a",
          url: "https://saleprice.in/collections/mi-redmi-10a-mobile-accessories-collection",
        },
        {
          name: "Red10c",
          url: "https://saleprice.in/collections/mi-redmi-10c-mobile-accessories-collection",
        },
        {
          name: "Red10c Red10 Red10 Power",
          url: "https://saleprice.in/collections/mi-redmi-10c-redmi-10-redmi-10-power-mobile-accessories-collection",
        },
        {
          name: "Red11 Prime 4g",
          url: "https://saleprice.in/collections/mi-redmi-11-prime-4g-mobile-accessories-collection",
        },
        {
          name: "Red11 Prime 5g",
          url: "https://saleprice.in/collections/mi-redmi-11-prime-5g-mobile-accessories-collection",
        },
        {
          name: "Red11 Pro",
          url: "https://saleprice.in/collections/mi-redmi-11-pro-mobile-accessories-collection",
        },
        {
          name: "Red11 Pro Plus",
          url: "https://saleprice.in/collections/mi-redmi-11-pro-plus-mobile-accessories-collection",
        },
        {
          name: "Red11 Pro Red11 Pro Plus",
          url: "https://saleprice.in/collections/mi-redmi-11-pro-redmi-11-pro-plus-mobile-accessories-collection",
        },
        {
          name: "Red12 4g",
          url: "https://saleprice.in/collections/mi-redmi-12-4g-mobile-accessories-collection",
        },
        {
          name: "Red12 5g",
          url: "https://saleprice.in/collections/mi-redmi-12-5g-mobile-accessories-collection",
        },
        {
          name: "Red12 5g Poco M6 Pro 5g",
          url: "https://saleprice.in/collections/mi-redmi-12-5g-poco-m6-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Red12c",
          url: "https://saleprice.in/collections/mi-redmi-12c-mobile-accessories-collection",
        },
        {
          name: "Red13 5g Poco M6 Plus",
          url: "https://saleprice.in/collections/mi-redmi-13-5g-mi-poco-m6-plus-mobile-accessories-collection",
        },
        {
          name: "Red13c 4g",
          url: "https://saleprice.in/collections/mi-redmi-13c-4g-mobile-accessories-collection",
        },
        {
          name: "Red13c 5g",
          url: "https://saleprice.in/collections/mi-redmi-13c-5g-mobile-accessories-collection",
        },
        {
          name: "Red14c",
          url: "https://saleprice.in/collections/mi-redmi-14c-mobile-accessories-collection",
        },
        {
          name: "Red1s",
          url: "https://saleprice.in/collections/mi-redmi-1s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red2",
          url: "https://saleprice.in/collections/mi-redmi-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red2 Prime",
          url: "https://saleprice.in/collections/mi-redmi-2-prime-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red3s",
          url: "https://saleprice.in/collections/mi-redmi-3s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red3s Prime",
          url: "https://saleprice.in/collections/mi-redmi-3s-prime-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red3s Prime",
          url: "https://saleprice.in/collections/mi-redmi-3s-prime-mobile-accessories-collection",
        },
        {
          name: "Red4",
          url: "https://saleprice.in/collections/mi-redmi-4-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red4a",
          url: "https://saleprice.in/collections/mi-redmi-4a-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red5",
          url: "https://saleprice.in/collections/mi-redmi-5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red5a",
          url: "https://saleprice.in/collections/mi-redmi-5a-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red6",
          url: "https://saleprice.in/collections/mi-redmi-6-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red6 Pro",
          url: "https://saleprice.in/collections/mi-redmi-6-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red6a",
          url: "https://saleprice.in/collections/mi-redmi-6a-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red7",
          url: "https://saleprice.in/collections/mi-redmi-7-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red7a",
          url: "https://saleprice.in/collections/mi-redmi-7a-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red8",
          url: "https://saleprice.in/collections/mi-redmi-8-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red8a",
          url: "https://saleprice.in/collections/mi-redmi-8a-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red8a Dual",
          url: "https://saleprice.in/collections/mi-redmi-8a-dual-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Red9",
          url: "https://saleprice.in/collections/mi-redmi-9-mobile-accessories-collection",
        },
        {
          name: "Red9 1",
          url: "https://saleprice.in/collections/mi-redmi-9-mobile-accessories-collection-1",
        },
        {
          name: "Red9 Power 1",
          url: "https://saleprice.in/collections/mi-redmi-9-power-mobile-accessories-collection-1",
        },
        {
          name: "Red9 Prime",
          url: "https://saleprice.in/collections/mi-redmi-9-prime-mobile-accessories-collection",
        },
        {
          name: "Red9 Prime Poco M2",
          url: "https://saleprice.in/collections/mi-redmi-9-prime-poco-m2-mobile-accessories-collection",
        },
        {
          name: "Red9a",
          url: "https://saleprice.in/collections/mi-redmi-9a-mobile-accessories-collection",
        },
        {
          name: "Red9a 9i 9i Sport",
          url: "https://saleprice.in/collections/mi-redmi-9a-9i-9i-sport-mobile-accessories-collection",
        },
        {
          name: "Red9c",
          url: "https://saleprice.in/collections/mi-redmi-9c-mobile-accessories-collection",
        },
        {
          name: "Red9i",
          url: "https://saleprice.in/collections/mi-redmi-9i-mobile-accessories-collection",
        },
        {
          name: "Red9i Sport",
          url: "https://saleprice.in/collections/mi-redmi-9i-sport-mobile-accessories-collection",
        },
        {
          name: "Reda1",
          url: "https://saleprice.in/collections/mi-redmi-a1-mobile-accessories-collection",
        },
        {
          name: "Reda1 A2 Poco C50 C51",
          url: "https://saleprice.in/collections/mi-redmi-a1-a2-poco-c50-c51-mobile-accessories-collection",
        },
        {
          name: "Reda1 Plus",
          url: "https://saleprice.in/collections/mi-redmi-a1-plus-mobile-accessories-collection",
        },
        {
          name: "Reda2",
          url: "https://saleprice.in/collections/mi-redmi-a2-mobile-accessories-collection",
        },
        {
          name: "Reda2 Plus",
          url: "https://saleprice.in/collections/mi-redmi-a2-plus-mobile-accessories-collection",
        },
        {
          name: "Reda3 2024",
          url: "https://saleprice.in/collections/mi-redmi-a3-2024-mobile-accessories-collection",
        },
        {
          name: "Reda3x",
          url: "https://saleprice.in/collections/mi-redmi-a3x-mobile-accessories-collection",
        },
        {
          name: "Redgo",
          url: "https://saleprice.in/collections/mi-redmi-go-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Redk20",
          url: "https://saleprice.in/collections/mi-redmi-k20-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Redk20 Pro K20",
          url: "https://saleprice.in/collections/mi-redmi-k20-pro-k20-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote",
          url: "https://saleprice.in/collections/mi-redmi-note-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 10",
          url: "https://saleprice.in/collections/mi-redmi-note-10-mobile-accessories-collection",
        },
        {
          name: "Rednote 10 1",
          url: "https://saleprice.in/collections/mi-redmi-note-10-mobile-accessories-collection-1",
        },
        {
          name: "Rednote 10 10s",
          url: "https://saleprice.in/collections/mi-redmi-note-10-10s-mobile-accessories-collection",
        },
        {
          name: "Rednote 10 Pro",
          url: "https://saleprice.in/collections/mi-redmi-note-10-pro-mobile-accessories-collection",
        },
        {
          name: "Rednote 10 Pro 5g",
          url: "https://saleprice.in/collections/mi-redmi-note-10-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Rednote 10 Pro Max",
          url: "https://saleprice.in/collections/mi-redmi-note-10-pro-max-mobile-accessories-collection",
        },
        {
          name: "Rednote 10s",
          url: "https://saleprice.in/collections/mi-redmi-note-10s-mobile-accessories-collection",
        },
        {
          name: "Rednote 10t",
          url: "https://saleprice.in/collections/mi-redmi-note-10t-mobile-accessories-collection",
        },
        {
          name: "Rednote 10t 5g",
          url: "https://saleprice.in/collections/mi-redmi-note-10t-5g-mobile-accessories-collection",
        },
        {
          name: "Rednote 11",
          url: "https://saleprice.in/collections/mi-redmi-note-11-mobile-accessories-collection",
        },
        {
          name: "Rednote 11 1",
          url: "https://saleprice.in/collections/mi-redmi-note-11-mobile-accessories-collection-1",
        },
        {
          name: "Rednote 11 Note 11s",
          url: "https://saleprice.in/collections/mi-redmi-note-11-note-11s-mobile-accessories-collection",
        },
        {
          name: "Rednote 11 Pro",
          url: "https://saleprice.in/collections/mi-redmi-note-11-pro-mobile-accessories-collection",
        },
        {
          name: "Rednote 11 Pro 1",
          url: "https://saleprice.in/collections/mi-redmi-note-11-pro-mobile-accessories-collection-1",
        },
        {
          name: "Rednote 11 Pro Plus 5g",
          url: "https://saleprice.in/collections/mi-redmi-note-11-pro-plus-5g-mobile-accessories-collection",
        },
        {
          name: "Rednote 11 Pro Rednote11 Pro",
          url: "https://saleprice.in/collections/mi-redmi-note-11-pro-redmi-note11-pro-mobile-accessories-collection",
        },
        {
          name: "Rednote 11r",
          url: "https://saleprice.in/collections/mi-redmi-note-11r-mobile-accessories-collection",
        },
        {
          name: "Rednote 11s",
          url: "https://saleprice.in/collections/mi-redmi-note-11s-mobile-accessories-collection",
        },
        {
          name: "Rednote 11se",
          url: "https://saleprice.in/collections/mi-redmi-note-11se-mobile-accessories-collection",
        },
        {
          name: "Rednote 11t",
          url: "https://saleprice.in/collections/mi-redmi-note-11t-mobile-accessories-collection",
        },
        {
          name: "Rednote 12",
          url: "https://saleprice.in/collections/mi-redmi-note-12-mobile-accessories-collection",
        },
        {
          name: "Rednote 12 4g",
          url: "https://saleprice.in/collections/mi-redmi-note-12-4g-mobile-accessories-collection",
        },
        {
          name: "Rednote 12 Pro",
          url: "https://saleprice.in/collections/mi-redmi-note-12-pro-mobile-accessories-collection",
        },
        {
          name: "Rednote 12 Pro 5g",
          url: "https://saleprice.in/collections/mi-redmi-note-12-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Rednote 12 Pro Plus",
          url: "https://saleprice.in/collections/mi-redmi-note-12-pro-plus-mobile-accessories-collection",
        },
        {
          name: "Rednote 13",
          url: "https://saleprice.in/collections/mi-redmi-note-13-mobile-accessories-collection",
        },
        {
          name: "Rednote 13 Pro",
          url: "https://saleprice.in/collections/mi-redmi-note-13-pro-mobile-accessories-collection",
        },
        {
          name: "Rednote 13 Pro 5g",
          url: "https://saleprice.in/collections/mi-redmi-note-13-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Rednote 13 Pro Plus",
          url: "https://saleprice.in/collections/mi-redmi-note-13-pro-plus-mobile-accessories-collection",
        },
        {
          name: "Rednote 14 5g",
          url: "https://saleprice.in/collections/mi-redmi-note-14-5g-mobile-accessories-collection",
        },
        {
          name: "Rednote 14 Pro",
          url: "https://saleprice.in/collections/mi-redmi-note-14-pro-mobile-accessories-collection",
        },
        {
          name: "Rednote 14 Pro Plus",
          url: "https://saleprice.in/collections/mi-redmi-note-14-pro-plus-mobile-accessories-collection",
        },
        {
          name: "Rednote 3",
          url: "https://saleprice.in/collections/mi-redmi-note-3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 4",
          url: "https://saleprice.in/collections/mi-redmi-note-4-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 5",
          url: "https://saleprice.in/collections/mi-redmi-note-5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 5 Pro",
          url: "https://saleprice.in/collections/mi-redmi-note-5-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 6 Pro",
          url: "https://saleprice.in/collections/mi-redmi-note-6-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 7",
          url: "https://saleprice.in/collections/mi-redmi-note-7-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 7 Pro",
          url: "https://saleprice.in/collections/mi-redmi-note-7-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 7s",
          url: "https://saleprice.in/collections/mi-redmi-note-7s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 8",
          url: "https://saleprice.in/collections/mi-redmi-note-8-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 8 Pro",
          url: "https://saleprice.in/collections/mi-redmi-note-8-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 8t",
          url: "https://saleprice.in/collections/mi-redmi-note-8t-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Rednote 9",
          url: "https://saleprice.in/collections/mi-redmi-note-9-mobile-accessories-collection",
        },
        {
          name: "Rednote 9 Pro",
          url: "https://saleprice.in/collections/mi-redmi-note-9-pro-mobile-accessories-collection",
        },
        {
          name: "Rednote 9 Pro Max",
          url: "https://saleprice.in/collections/mi-redmi-note-9-pro-max-mobile-accessories-collection",
        },
        {
          name: "Rednote11 Pro Plus",
          url: "https://saleprice.in/collections/mi-redmi-note11-pro-plus-mobile-accessories-collection",
        },
        {
          name: "Redpad",
          url: "https://saleprice.in/collections/mi-redmi-pad-mobile-accessories-collection",
        },
        {
          name: "Redy1",
          url: "https://saleprice.in/collections/mi-redmi-y1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Redy1 Lite",
          url: "https://saleprice.in/collections/mi-redmi-y1-lite-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Redy2",
          url: "https://saleprice.in/collections/mi-redmi-y2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Redy2 1",
          url: "https://saleprice.in/collections/mi-redmi-y2-back-cover-tempered-glass-and-other-mobile-accessories-collection-1",
        },
        {
          name: "Redy3",
          url: "https://saleprice.in/collections/mi-redmi-y3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
      Poco: [
        {
          name: "C3",
          url: "https://saleprice.in/collections/poco-c3-mobile-accessories-collection",
        },
        {
          name: "F3",
          url: "https://saleprice.in/collections/poco-f3-mobile-accessories-collection",
        },
        {
          name: "F3 1",
          url: "https://saleprice.in/collections/poco-f3-mobile-accessories-collection-1",
        },
        {
          name: "M6 5g",
          url: "https://saleprice.in/collections/poco-m6-5g-mobile-accessories-collection",
        },
      ],
      Xiaomi: [
        {
          name: "11t Pro",
          url: "https://saleprice.in/collections/xiaomi-11t-pro-mobile-accessories-collection",
        },
        {
          name: "12 Pro 5g",
          url: "https://saleprice.in/collections/xiaomi-12-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Mi A1",
          url: "https://saleprice.in/collections/xiaomi-mi-a1-mobile-accessories-collection",
        },
        {
          name: "Redmi 13 5g",
          url: "https://saleprice.in/collections/xiaomi-redmi-13-5g-mobile-accessories-collection",
        },
        {
          name: "Redmi 14r",
          url: "https://saleprice.in/collections/xiaomi-redmi-14r-mobile-accessories-collection",
        },
        {
          name: "Redmi K20",
          url: "https://saleprice.in/collections/xiaomi-redmi-k20-mobile-accessories-collection",
        },
        {
          name: "Redmi K20 Pro",
          url: "https://saleprice.in/collections/xiaomi-redmi-k20-pro-mobile-accessories-collection",
        },
      ],
      Micromax: [
        {
          name: "Aq 5000",
          url: "https://saleprice.in/collections/micromax-aq-5000-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Bharat 2",
          url: "https://saleprice.in/collections/micromax-bharat-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Canvas 6 Pro",
          url: "https://saleprice.in/collections/micromax-canvas-6-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Canvas E4820 Dual",
          url: "https://saleprice.in/collections/micromax-canvas-e4820-dual-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "E313",
          url: "https://saleprice.in/collections/micromax-e313-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Evok Power",
          url: "https://saleprice.in/collections/micromax-evok-power-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
      Motorola: [
        {
          name: "E32s",
          url: "https://saleprice.in/collections/motorola-e32s-mobile-accessories-collection",
        },
      ],
      Nokia: [
        {
          name: "1",
          url: "https://saleprice.in/collections/nokia-1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "2",
          url: "https://saleprice.in/collections/nokia-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "2 1",
          url: "https://saleprice.in/collections/nokia-2-1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "2 2",
          url: "https://saleprice.in/collections/nokia-2-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "230",
          url: "https://saleprice.in/collections/nokia-230-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "3",
          url: "https://saleprice.in/collections/nokia-3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "3 1",
          url: "https://saleprice.in/collections/nokia-3-1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "3 1 Plus",
          url: "https://saleprice.in/collections/nokia-3-1-plus-mobile-accessories-collection",
        },
        {
          name: "3 2",
          url: "https://saleprice.in/collections/nokia-3-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "3310",
          url: "https://saleprice.in/collections/nokia-3310-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "4 2",
          url: "https://saleprice.in/collections/nokia-4-2-mobile-accessories-collection",
        },
        {
          name: "4 2 1",
          url: "https://saleprice.in/collections/nokia-4-2-mobile-accessories-collection-1",
        },
        {
          name: "5",
          url: "https://saleprice.in/collections/nokia-5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "5 1",
          url: "https://saleprice.in/collections/nokia-5-1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "5 1 Plus",
          url: "https://saleprice.in/collections/nokia-5-1-plus-mobile-accessories-collection",
        },
        {
          name: "6",
          url: "https://saleprice.in/collections/nokia-6-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "6 1",
          url: "https://saleprice.in/collections/nokia-6-1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "6 1 Plus",
          url: "https://saleprice.in/collections/nokia-6-1-plus-mobile-accessories-collection",
        },
        {
          name: "6 2",
          url: "https://saleprice.in/collections/nokia-6-2-mobile-accessories-collection",
        },
        {
          name: "7 1",
          url: "https://saleprice.in/collections/nokia-7-1-mobile-accessories-collection",
        },
        {
          name: "7 2",
          url: "https://saleprice.in/collections/nokia-7-2-mobile-accessories-collection",
        },
        {
          name: "8 1",
          url: "https://saleprice.in/collections/nokia-8-1-mobile-accessories-collection",
        },
        {
          name: "8 Sirocco",
          url: "https://saleprice.in/collections/nokia-8-sirocco-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "C01 Plus",
          url: "https://saleprice.in/collections/nokia-c01-plus-mobile-accessories-collection",
        },
        {
          name: "C12 Pro",
          url: "https://saleprice.in/collections/nokia-c12-pro-mobile-accessories-collection",
        },
        {
          name: "G11 Plus",
          url: "https://saleprice.in/collections/nokia-g11-plus-mobile-accessories-collection",
        },
        {
          name: "G42",
          url: "https://saleprice.in/collections/nokia-g42-mobile-accessories-collection",
        },
        {
          name: "Tab T20",
          url: "https://saleprice.in/collections/nokia-tab-t20-mobile-accessories-collection",
        },
      ],
      Nothing: [
        {
          name: "Cmf Phone 2 Pro",
          url: "https://saleprice.in/collections/nothing-cmf-phone-2-pro-mobile-accessories-collection",
        },
        {
          name: "Phone 1",
          url: "https://saleprice.in/collections/nothing-phone-1-mobile-accessories-collection",
        },
        {
          name: "Phone 1 1",
          url: "https://saleprice.in/collections/nothing-phone-1-mobile-accessories-collection-1",
        },
        {
          name: "Phone 2",
          url: "https://saleprice.in/collections/nothing-phone-2-mobile-accessories-collection",
        },
        {
          name: "Phone 2 1",
          url: "https://saleprice.in/collections/nothing-phone-2-mobile-accessories-collection-1",
        },
        {
          name: "Phone 2a",
          url: "https://saleprice.in/collections/nothing-phone-2a-mobile-accessories-collection",
        },
        {
          name: "Phone 3",
          url: "https://saleprice.in/collections/nothing-phone-3-mobile-accessories-collection",
        },
        {
          name: "Phone 3a",
          url: "https://saleprice.in/collections/nothing-phone-3a-mobile-accessories-collection",
        },
        {
          name: "Phone 3a Pro",
          url: "https://saleprice.in/collections/nothing-phone-3a-pro-mobile-accessories-collection",
        },
        {
          name: "Phone Cmf 1",
          url: "https://saleprice.in/collections/nothing-phone-cmf-1-mobile-accessories-collection",
        },
      ],
      Oneplus: [
        {
          name: "10 Pro",
          url: "https://saleprice.in/collections/oneplus-10-pro-mobile-accessories-collection",
        },
        {
          name: "10r",
          url: "https://saleprice.in/collections/oneplus-10r-mobile-accessories-collection",
        },
        {
          name: "10t",
          url: "https://saleprice.in/collections/oneplus-10t-mobile-accessories-collection",
        },
        {
          name: "11",
          url: "https://saleprice.in/collections/oneplus-11-mobile-accessories-collection",
        },
        {
          name: "11r",
          url: "https://saleprice.in/collections/oneplus-11r-mobile-accessories-collection",
        },
        {
          name: "12",
          url: "https://saleprice.in/collections/oneplus-12-mobile-accessories-collection",
        },
        {
          name: "12 1",
          url: "https://saleprice.in/collections/oneplus-12-mobile-accessories-collection-1",
        },
        {
          name: "12r",
          url: "https://saleprice.in/collections/oneplus-12r-mobile-accessories-collection",
        },
        {
          name: "13",
          url: "https://saleprice.in/collections/oneplus-13-mobile-accessories-collection",
        },
        {
          name: "13r",
          url: "https://saleprice.in/collections/oneplus-13r-mobile-accessories-collection",
        },
        {
          name: "13s",
          url: "https://saleprice.in/collections/oneplus-13s-mobile-accessories-collection",
        },
        {
          name: "13t",
          url: "https://saleprice.in/collections/oneplus-13t-mobile-accessories-collection",
        },
        {
          name: "2",
          url: "https://saleprice.in/collections/oneplus-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "3",
          url: "https://saleprice.in/collections/oneplus-3-mobile-accessories-collection",
        },
        {
          name: "3 3t",
          url: "https://saleprice.in/collections/oneplus-3-oneplus-3t-mobile-accessories-collection",
        },
        {
          name: "3t",
          url: "https://saleprice.in/collections/oneplus-3t-mobile-accessories-collection",
        },
        {
          name: "5",
          url: "https://saleprice.in/collections/oneplus-5-mobile-accessories-collection",
        },
        {
          name: "5t",
          url: "https://saleprice.in/collections/oneplus-5t-mobile-accessories-collection",
        },
        {
          name: "6",
          url: "https://saleprice.in/collections/oneplus-6-mobile-accessories-collection",
        },
        {
          name: "6t",
          url: "https://saleprice.in/collections/oneplus-6t-mobile-accessories-collection",
        },
        {
          name: "7",
          url: "https://saleprice.in/collections/oneplus-7-mobile-accessories-collection",
        },
        {
          name: "7 Pro",
          url: "https://saleprice.in/collections/oneplus-7-pro-mobile-accessories-collection",
        },
        {
          name: "7t",
          url: "https://saleprice.in/collections/oneplus-7t-mobile-accessories-collection",
        },
        {
          name: "7t Pro",
          url: "https://saleprice.in/collections/oneplus-7t-pro-mobile-accessories-collection",
        },
        {
          name: "8",
          url: "https://saleprice.in/collections/oneplus-8-mobile-accessories-collection",
        },
        {
          name: "8 Pro",
          url: "https://saleprice.in/collections/oneplus-8-pro-mobile-accessories-collection",
        },
        {
          name: "8t",
          url: "https://saleprice.in/collections/oneplus-8t-mobile-accessories-collection",
        },
        {
          name: "9",
          url: "https://saleprice.in/collections/oneplus-9-mobile-accessories-collection",
        },
        {
          name: "9 Pro",
          url: "https://saleprice.in/collections/oneplus-9-pro-mobile-accessories-collection",
        },
        {
          name: "9r",
          url: "https://saleprice.in/collections/oneplus-9r-mobile-accessories-collection",
        },
        {
          name: "9rt",
          url: "https://saleprice.in/collections/oneplus-9rt-mobile-accessories-collection",
        },
        {
          name: "Ace",
          url: "https://saleprice.in/collections/oneplus-ace-mobile-accessories-collection",
        },
        {
          name: "Ace 2",
          url: "https://saleprice.in/collections/oneplus-ace-2-mobile-accessories-collection",
        },
        {
          name: "Nord",
          url: "https://saleprice.in/collections/oneplus-nord-mobile-accessories-collection",
        },
        {
          name: "Nord 1",
          url: "https://saleprice.in/collections/oneplus-nord-mobile-accessories-collection-1",
        },
        {
          name: "Nord 2",
          url: "https://saleprice.in/collections/oneplus-nord-2-mobile-accessories-collection",
        },
        {
          name: "Nord 2 1",
          url: "https://saleprice.in/collections/oneplus-nord-2-mobile-accessories-collection-1",
        },
        {
          name: "Nord 2t",
          url: "https://saleprice.in/collections/oneplus-nord-2t-mobile-accessories-collection",
        },
        {
          name: "Nord 2t 1",
          url: "https://saleprice.in/collections/oneplus-nord-2t-mobile-accessories-collection-1",
        },
        {
          name: "Nord 3",
          url: "https://saleprice.in/collections/oneplus-nord-3-mobile-accessories-collection",
        },
        {
          name: "Nord 3 1",
          url: "https://saleprice.in/collections/oneplus-nord-3-mobile-accessories-collection-1",
        },
        {
          name: "Nord 4",
          url: "https://saleprice.in/collections/oneplus-nord-4-mobile-accessories-collection",
        },
        {
          name: "Nord 5",
          url: "https://saleprice.in/collections/oneplus-nord-5-mobile-accessories-collection",
        },
        {
          name: "Nord Ce",
          url: "https://saleprice.in/collections/oneplus-nord-ce-mobile-accessories-collection",
        },
        {
          name: "Nord Ce2",
          url: "https://saleprice.in/collections/oneplus-nord-ce2-mobile-accessories-collection",
        },
        {
          name: "Nord Ce2 Lite 1",
          url: "https://saleprice.in/collections/oneplus-nord-ce2-lite-mobile-accessories-collection-1",
        },
        {
          name: "Nord Ce3",
          url: "https://saleprice.in/collections/oneplus-nord-ce3-mobile-accessories-collection",
        },
        {
          name: "Nord Ce3 Lite",
          url: "https://saleprice.in/collections/oneplus-nord-ce3-lite-mobile-accessories-collection",
        },
        {
          name: "Nord Ce4",
          url: "https://saleprice.in/collections/oneplus-nord-ce4-mobile-accessories-collection",
        },
        {
          name: "Nord Ce4 Lite",
          url: "https://saleprice.in/collections/oneplus-nord-ce4-lite-mobile-accessories-collection",
        },
        {
          name: "Nord Ce5",
          url: "https://saleprice.in/collections/oneplus-nord-ce5-mobile-accessories-collection",
        },
        {
          name: "Nord N20 Se",
          url: "https://saleprice.in/collections/oneplus-nord-n20-se-mobile-accessories-collection",
        },
        {
          name: "Nord N30",
          url: "https://saleprice.in/collections/oneplus-nord-n30-mobile-accessories-collection",
        },
        {
          name: "One",
          url: "https://saleprice.in/collections/oneplus-one-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "One",
          url: "https://saleprice.in/collections/oneplus-one-mobile-accessories-collection",
        },
        {
          name: "One 1",
          url: "https://saleprice.in/collections/oneplus-one-mobile-accessories-collection-1",
        },
      ],
      Oppo: [
        {
          name: "A11k",
          url: "https://saleprice.in/collections/oppo-a11k-mobile-accessories-collection",
        },
        {
          name: "A12",
          url: "https://saleprice.in/collections/oppo-a12-mobile-accessories-collection",
        },
        {
          name: "A15",
          url: "https://saleprice.in/collections/oppo-a15-mobile-accessories-collection",
        },
        {
          name: "A16",
          url: "https://saleprice.in/collections/oppo-a16-mobile-accessories-collection",
        },
        {
          name: "A16e",
          url: "https://saleprice.in/collections/oppo-a16e-mobile-accessories-collection",
        },
        {
          name: "A16k",
          url: "https://saleprice.in/collections/oppo-a16k-mobile-accessories-collection",
        },
        {
          name: "A17",
          url: "https://saleprice.in/collections/oppo-a17-mobile-accessories-collection",
        },
        {
          name: "A17k",
          url: "https://saleprice.in/collections/oppo-a17k-mobile-accessories-collection",
        },
        {
          name: "A18 4g",
          url: "https://saleprice.in/collections/oppo-a18-4g-mobile-accessories-collection",
        },
        {
          name: "A1k",
          url: "https://saleprice.in/collections/oppo-a1k-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A3 Pro",
          url: "https://saleprice.in/collections/oppo-a3-pro-mobile-accessories-collection",
        },
        {
          name: "A31",
          url: "https://saleprice.in/collections/oppo-a31-mobile-accessories-collection",
        },
        {
          name: "A33",
          url: "https://saleprice.in/collections/oppo-a33-mobile-accessories-collection",
        },
        {
          name: "A37",
          url: "https://saleprice.in/collections/oppo-a37-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A38 4g",
          url: "https://saleprice.in/collections/oppo-a38-4g-mobile-accessories-collection",
        },
        {
          name: "A3s",
          url: "https://saleprice.in/collections/oppo-a3s-mobile-accessories-collection",
        },
        {
          name: "A3x",
          url: "https://saleprice.in/collections/oppo-a3x-mobile-accessories-collection",
        },
        {
          name: "A5",
          url: "https://saleprice.in/collections/oppo-a5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A5",
          url: "https://saleprice.in/collections/oppo-a5-mobile-accessories-collection",
        },
        {
          name: "A5 2020",
          url: "https://saleprice.in/collections/oppo-a5-2020-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A5 2020",
          url: "https://saleprice.in/collections/oppo-a5-2020-mobile-accessories-collection",
        },
        {
          name: "A5 Pro",
          url: "https://saleprice.in/collections/oppo-a5-pro-mobile-accessories-collection",
        },
        {
          name: "A52",
          url: "https://saleprice.in/collections/oppo-a52-mobile-accessories-collection",
        },
        {
          name: "A52 1",
          url: "https://saleprice.in/collections/oppo-a52-mobile-accessories-collection-1",
        },
        {
          name: "A53",
          url: "https://saleprice.in/collections/oppo-a53-mobile-accessories-collection",
        },
        {
          name: "A53s",
          url: "https://saleprice.in/collections/oppo-a53s-mobile-accessories-collection",
        },
        {
          name: "A53s 1",
          url: "https://saleprice.in/collections/oppo-a53s-mobile-accessories-collection-1",
        },
        {
          name: "A54",
          url: "https://saleprice.in/collections/oppo-a54-mobile-accessories-collection",
        },
        {
          name: "A54 5g",
          url: "https://saleprice.in/collections/oppo-a54-5g-mobile-accessories-collection",
        },
        {
          name: "A55 4g",
          url: "https://saleprice.in/collections/oppo-a55-4g-mobile-accessories-collection",
        },
        {
          name: "A55 5g",
          url: "https://saleprice.in/collections/oppo-a55-5g-mobile-accessories-collection",
        },
        {
          name: "A57",
          url: "https://saleprice.in/collections/oppo-a57-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A57 5g",
          url: "https://saleprice.in/collections/oppo-a57-5g-mobile-accessories-collection",
        },
        {
          name: "A57e 4g",
          url: "https://saleprice.in/collections/oppo-a57e-4g-mobile-accessories-collection",
        },
        {
          name: "A58",
          url: "https://saleprice.in/collections/oppo-a58-mobile-accessories-collection",
        },
        {
          name: "A59",
          url: "https://saleprice.in/collections/oppo-a59-mobile-accessories-collection",
        },
        {
          name: "A59 5g",
          url: "https://saleprice.in/collections/oppo-a59-5g-mobile-accessories-collection",
        },
        {
          name: "A5s",
          url: "https://saleprice.in/collections/oppo-a5s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A5s",
          url: "https://saleprice.in/collections/oppo-a5s-mobile-accessories-collection",
        },
        {
          name: "A5x",
          url: "https://saleprice.in/collections/oppo-a5x-mobile-accessories-collection",
        },
        {
          name: "A7",
          url: "https://saleprice.in/collections/oppo-a7-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A7",
          url: "https://saleprice.in/collections/oppo-a7-mobile-accessories-collection",
        },
        {
          name: "A71",
          url: "https://saleprice.in/collections/oppo-a71-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A72",
          url: "https://saleprice.in/collections/oppo-a72-mobile-accessories-collection",
        },
        {
          name: "A74",
          url: "https://saleprice.in/collections/oppo-a74-mobile-accessories-collection",
        },
        {
          name: "A74 1",
          url: "https://saleprice.in/collections/oppo-a74-mobile-accessories-collection-1",
        },
        {
          name: "A74 5g",
          url: "https://saleprice.in/collections/oppo-a74-5g-mobile-accessories-collection",
        },
        {
          name: "A76",
          url: "https://saleprice.in/collections/oppo-a76-mobile-accessories-collection",
        },
        {
          name: "A77",
          url: "https://saleprice.in/collections/oppo-a77-mobile-accessories-collection",
        },
        {
          name: "A77 5g",
          url: "https://saleprice.in/collections/oppo-a77-5g-mobile-accessories-collection",
        },
        {
          name: "A77s",
          url: "https://saleprice.in/collections/oppo-a77s-mobile-accessories-collection",
        },
        {
          name: "A78",
          url: "https://saleprice.in/collections/oppo-a78-mobile-accessories-collection",
        },
        {
          name: "A78 5g",
          url: "https://saleprice.in/collections/oppo-a78-5g-mobile-accessories-collection",
        },
        {
          name: "A79 5g",
          url: "https://saleprice.in/collections/oppo-a79-5g-mobile-accessories-collection",
        },
        {
          name: "A83",
          url: "https://saleprice.in/collections/oppo-a83-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A9",
          url: "https://saleprice.in/collections/oppo-a9-mobile-accessories-collection",
        },
        {
          name: "A9 2020",
          url: "https://saleprice.in/collections/oppo-a9-2020-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "A92",
          url: "https://saleprice.in/collections/oppo-a92-mobile-accessories-collection",
        },
        {
          name: "A93 5g",
          url: "https://saleprice.in/collections/oppo-a93-5g-mobile-accessories-collection",
        },
        {
          name: "A94",
          url: "https://saleprice.in/collections/oppo-a94-mobile-accessories-collection",
        },
        {
          name: "A94 1",
          url: "https://saleprice.in/collections/oppo-a94-mobile-accessories-collection-1",
        },
        {
          name: "A96",
          url: "https://saleprice.in/collections/oppo-a96-mobile-accessories-collection",
        },
        {
          name: "F1",
          url: "https://saleprice.in/collections/oppo-f1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "F1 Plus",
          url: "https://saleprice.in/collections/oppo-f1-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "F11",
          url: "https://saleprice.in/collections/oppo-f11-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "F11",
          url: "https://saleprice.in/collections/oppo-f11-mobile-accessories-collection",
        },
        {
          name: "F11 Pro",
          url: "https://saleprice.in/collections/oppo-f11-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "F15",
          url: "https://saleprice.in/collections/oppo-f15-mobile-accessories-collection",
        },
        {
          name: "F17",
          url: "https://saleprice.in/collections/oppo-f17-mobile-accessories-collection",
        },
        {
          name: "F17 1",
          url: "https://saleprice.in/collections/oppo-f17-mobile-accessories-collection-1",
        },
        {
          name: "F17 Pro",
          url: "https://saleprice.in/collections/oppo-f17-pro-mobile-accessories-collection",
        },
        {
          name: "F17 Pro 1",
          url: "https://saleprice.in/collections/oppo-f17-pro-mobile-accessories-collection-1",
        },
        {
          name: "F19",
          url: "https://saleprice.in/collections/oppo-f19-mobile-accessories-collection",
        },
        {
          name: "F19 Pro 3",
          url: "https://saleprice.in/collections/oppo-f19-pro-mobile-accessories-collection-3",
        },
        {
          name: "F19 Pro Plus",
          url: "https://saleprice.in/collections/oppo-f19-pro-plus-mobile-accessories-collection",
        },
        {
          name: "F19 Pro Plus 1",
          url: "https://saleprice.in/collections/oppo-f19-pro-plus-mobile-accessories-collection-1",
        },
        {
          name: "F19s",
          url: "https://saleprice.in/collections/oppo-f19s-mobile-accessories-collection",
        },
        {
          name: "F1s",
          url: "https://saleprice.in/collections/oppo-f1s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "F21 Pro 4g",
          url: "https://saleprice.in/collections/oppo-f21-pro-4g-mobile-accessories-collection",
        },
        {
          name: "F21 Pro 5g",
          url: "https://saleprice.in/collections/oppo-f21-pro-5g-mobile-accessories-collection",
        },
        {
          name: "F21s Pro 4g",
          url: "https://saleprice.in/collections/oppo-f21s-pro-4g-mobile-accessories-collection",
        },
        {
          name: "F21s Pro 5g",
          url: "https://saleprice.in/collections/oppo-f21s-pro-5g-mobile-accessories-collection",
        },
        {
          name: "F23 5g",
          url: "https://saleprice.in/collections/oppo-f23-5g-mobile-accessories-collection",
        },
        {
          name: "F23 5g 1",
          url: "https://saleprice.in/collections/oppo-f23-5g-mobile-accessories-collection-1",
        },
        {
          name: "F25 Pro",
          url: "https://saleprice.in/collections/oppo-f25-pro-mobile-accessories-collection",
        },
        {
          name: "F27",
          url: "https://saleprice.in/collections/oppo-f27-mobile-accessories-collection",
        },
        {
          name: "F27 Pro",
          url: "https://saleprice.in/collections/oppo-f27-pro-mobile-accessories-collection",
        },
        {
          name: "F27 Pro Plus",
          url: "https://saleprice.in/collections/oppo-f27-pro-plus-mobile-accessories-collection",
        },
        {
          name: "F29",
          url: "https://saleprice.in/collections/oppo-f29-mobile-accessories-collection",
        },
        {
          name: "F29 Pro",
          url: "https://saleprice.in/collections/oppo-f29-pro-mobile-accessories-collection",
        },
        {
          name: "F3",
          url: "https://saleprice.in/collections/oppo-f3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "F3 Plus",
          url: "https://saleprice.in/collections/oppo-f3-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "F5",
          url: "https://saleprice.in/collections/oppo-f5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "F7",
          url: "https://saleprice.in/collections/oppo-f7-mobile-accessories-collection",
        },
        {
          name: "F7",
          url: "https://saleprice.in/collections/oppo-f7-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "F9",
          url: "https://saleprice.in/collections/oppo-f9-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "F9",
          url: "https://saleprice.in/collections/oppo-f9-mobile-accessories-collection",
        },
        {
          name: "F9 Pro",
          url: "https://saleprice.in/collections/oppo-f9-pro-mobile-accessories-collection",
        },
        {
          name: "F9 Pro F9",
          url: "https://saleprice.in/collections/oppo-f9-pro-oppo-f9-mobile-accessories-collection",
        },
        {
          name: "Find X8 Pro",
          url: "https://saleprice.in/collections/oppo-find-x8-pro-mobile-accessories-collection",
        },
        {
          name: "K1",
          url: "https://saleprice.in/collections/oppo-k1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "K10 4g",
          url: "https://saleprice.in/collections/oppo-k10-4g-mobile-accessories-collection",
        },
        {
          name: "K10 5g",
          url: "https://saleprice.in/collections/oppo-k10-5g-mobile-accessories-collection",
        },
        {
          name: "K10 5g 1",
          url: "https://saleprice.in/collections/oppo-k10-5g-mobile-accessories-collection-1",
        },
        {
          name: "K12x",
          url: "https://saleprice.in/collections/oppo-k12x-mobile-accessories-collection",
        },
        {
          name: "K12x 1",
          url: "https://saleprice.in/collections/oppo-k12x-mobile-accessories-collection-1",
        },
        {
          name: "K13",
          url: "https://saleprice.in/collections/oppo-k13-mobile-accessories-collection",
        },
        {
          name: "K13x",
          url: "https://saleprice.in/collections/oppo-k13x-mobile-accessories-collection",
        },
        {
          name: "K3",
          url: "https://saleprice.in/collections/oppo-k3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Neo 5 A31t",
          url: "https://saleprice.in/collections/oppo-neo-5-a31t-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Neo 7 A33",
          url: "https://saleprice.in/collections/oppo-neo-7-a33-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "R17 Pro",
          url: "https://saleprice.in/collections/oppo-r17-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "R7 Lite",
          url: "https://saleprice.in/collections/oppo-r7-lite-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Reno",
          url: "https://saleprice.in/collections/oppo-reno-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Reno 10",
          url: "https://saleprice.in/collections/oppo-reno-10-mobile-accessories-collection",
        },
        {
          name: "Reno 10 1",
          url: "https://saleprice.in/collections/oppo-reno-10-mobile-accessories-collection-1",
        },
        {
          name: "Reno 10 Pro",
          url: "https://saleprice.in/collections/oppo-reno-10-pro-mobile-accessories-collection",
        },
        {
          name: "Reno 10 Pro Plus",
          url: "https://saleprice.in/collections/oppo-reno-10-pro-plus-mobile-accessories-collection",
        },
        {
          name: "Reno 10x",
          url: "https://saleprice.in/collections/oppo-reno-10x-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Reno 11",
          url: "https://saleprice.in/collections/oppo-reno-11-mobile-accessories-collection",
        },
        {
          name: "Reno 11 Pro",
          url: "https://saleprice.in/collections/oppo-reno-11-pro-mobile-accessories-collection",
        },
        {
          name: "Reno 12",
          url: "https://saleprice.in/collections/oppo-reno-12-mobile-accessories-collection",
        },
        {
          name: "Reno 12 Pro",
          url: "https://saleprice.in/collections/oppo-reno-12-pro-mobile-accessories-collection",
        },
        {
          name: "Reno 13",
          url: "https://saleprice.in/collections/oppo-reno-13-mobile-accessories-collection",
        },
        {
          name: "Reno 13 Pro",
          url: "https://saleprice.in/collections/oppo-reno-13-pro-mobile-accessories-collection",
        },
        {
          name: "Reno 14",
          url: "https://saleprice.in/collections/oppo-reno-14-mobile-accessories-collection",
        },
        {
          name: "Reno 14 Pro",
          url: "https://saleprice.in/collections/oppo-reno-14-pro-mobile-accessories-collection",
        },
        {
          name: "Reno 14t",
          url: "https://saleprice.in/collections/oppo-reno-14t-mobile-accessories-collection",
        },
        {
          name: "Reno 2z",
          url: "https://saleprice.in/collections/oppo-reno-2z-mobile-accessories-collection",
        },
        {
          name: "Reno 3",
          url: "https://saleprice.in/collections/oppo-reno-3-mobile-accessories-collection",
        },
        {
          name: "Reno 3 Pro",
          url: "https://saleprice.in/collections/oppo-reno-3-pro-mobile-accessories-collection",
        },
        {
          name: "Reno 4",
          url: "https://saleprice.in/collections/oppo-reno-4-mobile-accessories-collection",
        },
        {
          name: "Reno 4 Pro",
          url: "https://saleprice.in/collections/oppo-reno-4-pro-mobile-accessories-collection",
        },
        {
          name: "Reno 5",
          url: "https://saleprice.in/collections/oppo-reno-5-mobile-accessories-collection",
        },
        {
          name: "Reno 5 Pro",
          url: "https://saleprice.in/collections/oppo-reno-5-pro-mobile-accessories-collection",
        },
        {
          name: "Reno 6",
          url: "https://saleprice.in/collections/oppo-reno-6-mobile-accessories-collection",
        },
        {
          name: "Reno 6 Pro",
          url: "https://saleprice.in/collections/oppo-reno-6-pro-mobile-accessories-collection",
        },
        {
          name: "Reno 7",
          url: "https://saleprice.in/collections/oppo-reno-7-mobile-accessories-collection",
        },
        {
          name: "Reno 7 Pro",
          url: "https://saleprice.in/collections/oppo-reno-7-pro-mobile-accessories-collection",
        },
        {
          name: "Reno 7z 5g",
          url: "https://saleprice.in/collections/oppo-reno-7z-5g-mobile-accessories-collection",
        },
        {
          name: "Reno 8",
          url: "https://saleprice.in/collections/oppo-reno-8-mobile-accessories-collection",
        },
        {
          name: "Reno 8 Pro",
          url: "https://saleprice.in/collections/oppo-reno-8-pro-mobile-accessories-collection",
        },
        {
          name: "Reno 8t",
          url: "https://saleprice.in/collections/oppo-reno-8t-mobile-accessories-collection",
        },
        {
          name: "Reno Z",
          url: "https://saleprice.in/collections/oppo-reno-z-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Reno Z2",
          url: "https://saleprice.in/collections/oppo-reno-z2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Reno7 5g",
          url: "https://saleprice.in/collections/oppo-reno7-5g-mobile-accessories-collection",
        },
        {
          name: "Reno8 5g",
          url: "https://saleprice.in/collections/oppo-reno8-5g-mobile-accessories-collection",
        },
      ],
      Panasonic: [
        {
          name: "Eluga A2",
          url: "https://saleprice.in/collections/panasonic-eluga-a2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Eluga I3",
          url: "https://saleprice.in/collections/panasonic-eluga-i3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Eluga Mark",
          url: "https://saleprice.in/collections/panasonic-eluga-mark-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Eluga Switch",
          url: "https://saleprice.in/collections/panasonic-eluga-switch-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Eluga Turbo",
          url: "https://saleprice.in/collections/panasonic-eluga-turbo-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "P55 Novo",
          url: "https://saleprice.in/collections/panasonic-p55-novo-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
      Realme: [
        {
          name: "1",
          url: "https://saleprice.in/collections/realme-1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "10",
          url: "https://saleprice.in/collections/realme-10-mobile-accessories-collection",
        },
        {
          name: "10 4g",
          url: "https://saleprice.in/collections/realme-10-4g-mobile-accessories-collection",
        },
        {
          name: "10 Pro",
          url: "https://saleprice.in/collections/realme-10-pro-mobile-accessories-collection",
        },
        {
          name: "10 Pro Plus",
          url: "https://saleprice.in/collections/realme-10-pro-plus-mobile-accessories-collection",
        },
        {
          name: "10a",
          url: "https://saleprice.in/collections/realme-10a-mobile-accessories-collection",
        },
        {
          name: "11 5g",
          url: "https://saleprice.in/collections/realme-11-5g-mobile-accessories-collection",
        },
        {
          name: "11 Pro",
          url: "https://saleprice.in/collections/realme-11-pro-mobile-accessories-collection",
        },
        {
          name: "11 Pro Plus",
          url: "https://saleprice.in/collections/realme-11-pro-plus-mobile-accessories-collection",
        },
        {
          name: "11x 5g",
          url: "https://saleprice.in/collections/realme-11x-5g-mobile-accessories-collection",
        },
        {
          name: "12 5g",
          url: "https://saleprice.in/collections/realme-12-5g-mobile-accessories-collection",
        },
        {
          name: "12 Plus 5g",
          url: "https://saleprice.in/collections/realme-12-plus-5g-mobile-accessories-collection",
        },
        {
          name: "12 Pro 5g",
          url: "https://saleprice.in/collections/realme-12-pro-5g-mobile-accessories-collection",
        },
        {
          name: "12 Pro Plus 5g",
          url: "https://saleprice.in/collections/realme-12-pro-plus-5g-mobile-accessories-collection",
        },
        {
          name: "12x 5g",
          url: "https://saleprice.in/collections/realme-12x-5g-mobile-accessories-collection",
        },
        {
          name: "13 5g",
          url: "https://saleprice.in/collections/realme-13-5g-mobile-accessories-collection",
        },
        {
          name: "13 Pro 5g",
          url: "https://saleprice.in/collections/realme-13-pro-5g-mobile-accessories-collection",
        },
        {
          name: "13 Pro Plus 5g",
          url: "https://saleprice.in/collections/realme-13-pro-plus-5g-mobile-accessories-collection",
        },
        {
          name: "14",
          url: "https://saleprice.in/collections/realme-14-mobile-accessories-collection",
        },
        {
          name: "14 Pro",
          url: "https://saleprice.in/collections/realme-14-pro-mobile-accessories-collection",
        },
        {
          name: "14 Pro Plus",
          url: "https://saleprice.in/collections/realme-14-pro-plus-mobile-accessories-collection",
        },
        {
          name: "14x",
          url: "https://saleprice.in/collections/realme-14x-mobile-accessories-collection",
        },
        {
          name: "15",
          url: "https://saleprice.in/collections/realme-15-mobile-accessories-collection",
        },
        {
          name: "2",
          url: "https://saleprice.in/collections/realme-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "2 Pro",
          url: "https://saleprice.in/collections/realme-2-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "3",
          url: "https://saleprice.in/collections/realme-3-mobile-accessories-collection",
        },
        {
          name: "3 Pro",
          url: "https://saleprice.in/collections/realme-3-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "3 Pro 1",
          url: "https://saleprice.in/collections/realme-3-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection-1",
        },
        {
          name: "3i",
          url: "https://saleprice.in/collections/realme-3i-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "3i",
          url: "https://saleprice.in/collections/realme-3i-mobile-accessories-collection",
        },
        {
          name: "5",
          url: "https://saleprice.in/collections/realme-5-mobile-accessories-collection",
        },
        {
          name: "5 Pro",
          url: "https://saleprice.in/collections/realme-5-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "5i",
          url: "https://saleprice.in/collections/realme-5i-mobile-accessories-collection",
        },
        {
          name: "5s",
          url: "https://saleprice.in/collections/realme-5s-mobile-accessories-collection",
        },
        {
          name: "6",
          url: "https://saleprice.in/collections/realme-6-mobile-accessories-collection",
        },
        {
          name: "6 Pro",
          url: "https://saleprice.in/collections/realme-6-pro-mobile-accessories-collection",
        },
        {
          name: "7",
          url: "https://saleprice.in/collections/realme-7-mobile-accessories-collection",
        },
        {
          name: "7 Pro",
          url: "https://saleprice.in/collections/realme-7-pro-mobile-accessories-collection",
        },
        {
          name: "7i",
          url: "https://saleprice.in/collections/realme-7i-mobile-accessories-collection",
        },
        {
          name: "8 4g",
          url: "https://saleprice.in/collections/realme-8-4g-mobile-accessories-collection",
        },
        {
          name: "8 5g",
          url: "https://saleprice.in/collections/realme-8-5g-mobile-accessories-collection",
        },
        {
          name: "8 Pro",
          url: "https://saleprice.in/collections/realme-8-pro-mobile-accessories-collection",
        },
        {
          name: "8i",
          url: "https://saleprice.in/collections/realme-8i-mobile-accessories-collection",
        },
        {
          name: "8s 5g",
          url: "https://saleprice.in/collections/realme-8s-5g-mobile-accessories-collection",
        },
        {
          name: "9 4g",
          url: "https://saleprice.in/collections/realme-9-4g-mobile-accessories-collection",
        },
        {
          name: "9 5g",
          url: "https://saleprice.in/collections/realme-9-5g-mobile-accessories-collection",
        },
        {
          name: "9 5g 1",
          url: "https://saleprice.in/collections/realme-9-5g-mobile-accessories-collection-1",
        },
        {
          name: "9 Pro",
          url: "https://saleprice.in/collections/realme-9-pro-mobile-accessories-collection",
        },
        {
          name: "9 Pro 5g",
          url: "https://saleprice.in/collections/realme-9-pro-5g-mobile-accessories-collection",
        },
        {
          name: "9 Pro Plus",
          url: "https://saleprice.in/collections/realme-9-pro-plus-mobile-accessories-collection",
        },
        {
          name: "9i",
          url: "https://saleprice.in/collections/realme-9i-mobile-accessories-collection",
        },
        {
          name: "9i 4g",
          url: "https://saleprice.in/collections/realme-9i-4g-mobile-accessories-collection",
        },
        {
          name: "9i 4g 1",
          url: "https://saleprice.in/collections/realme-9i-4g-mobile-accessories-collection-1",
        },
        {
          name: "9se 5g",
          url: "https://saleprice.in/collections/realme-9se-5g-mobile-accessories-collection",
        },
        {
          name: "A11k",
          url: "https://saleprice.in/collections/realme-a11k-mobile-accessories-collection",
        },
        {
          name: "C1",
          url: "https://saleprice.in/collections/realme-c1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "C1",
          url: "https://saleprice.in/collections/realme-c1-mobile-accessories-collection",
        },
        {
          name: "C11",
          url: "https://saleprice.in/collections/realme-c11-mobile-accessories-collection",
        },
        {
          name: "C11 2020",
          url: "https://saleprice.in/collections/realme-c11-2020-mobile-accessories-collection",
        },
        {
          name: "C11 2021",
          url: "https://saleprice.in/collections/realme-c11-2021-mobile-accessories-collection",
        },
        {
          name: "C12",
          url: "https://saleprice.in/collections/realme-c12-mobile-accessories-collection",
        },
        {
          name: "C15",
          url: "https://saleprice.in/collections/realme-c15-mobile-accessories-collection",
        },
        {
          name: "C17",
          url: "https://saleprice.in/collections/realme-c17-mobile-accessories-collection",
        },
        {
          name: "C2",
          url: "https://saleprice.in/collections/realme-c2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "C20",
          url: "https://saleprice.in/collections/realme-c20-mobile-accessories-collection",
        },
        {
          name: "C21",
          url: "https://saleprice.in/collections/realme-c21-mobile-accessories-collection",
        },
        {
          name: "C21y",
          url: "https://saleprice.in/collections/realme-c21y-mobile-accessories-collection",
        },
        {
          name: "C25",
          url: "https://saleprice.in/collections/realme-c25-mobile-accessories-collection",
        },
        {
          name: "C25s",
          url: "https://saleprice.in/collections/realme-c25s-mobile-accessories-collection",
        },
        {
          name: "C25y",
          url: "https://saleprice.in/collections/realme-c25y-mobile-accessories-collection",
        },
        {
          name: "C3",
          url: "https://saleprice.in/collections/realme-c3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "C30",
          url: "https://saleprice.in/collections/realme-c30-mobile-accessories-collection",
        },
        {
          name: "C30s",
          url: "https://saleprice.in/collections/realme-c30s-mobile-accessories-collection",
        },
        {
          name: "C31",
          url: "https://saleprice.in/collections/realme-c31-mobile-accessories-collection",
        },
        {
          name: "C33",
          url: "https://saleprice.in/collections/realme-c33-mobile-accessories-collection",
        },
        {
          name: "C35",
          url: "https://saleprice.in/collections/realme-c35-mobile-accessories-collection",
        },
        {
          name: "C51 4g",
          url: "https://saleprice.in/collections/realme-c51-4g-mobile-accessories-collection",
        },
        {
          name: "C53",
          url: "https://saleprice.in/collections/realme-c53-mobile-accessories-collection",
        },
        {
          name: "C55",
          url: "https://saleprice.in/collections/realme-c55-mobile-accessories-collection",
        },
        {
          name: "C61 4g",
          url: "https://saleprice.in/collections/realme-c61-4g-mobile-accessories-collection",
        },
        {
          name: "C63 4g",
          url: "https://saleprice.in/collections/realme-c63-4g-mobile-accessories-collection",
        },
        {
          name: "C63 5g",
          url: "https://saleprice.in/collections/realme-c63-5g-mobile-accessories-collection",
        },
        {
          name: "C65 5g",
          url: "https://saleprice.in/collections/realme-c65-5g-mobile-accessories-collection",
        },
        {
          name: "C67 5g",
          url: "https://saleprice.in/collections/realme-c67-5g-mobile-accessories-collection",
        },
        {
          name: "C73 5g",
          url: "https://saleprice.in/collections/realme-c73-5g-mobile-accessories-collection",
        },
        {
          name: "C75 4g",
          url: "https://saleprice.in/collections/realme-c75-4g-mobile-accessories-collection",
        },
        {
          name: "C75 5g",
          url: "https://saleprice.in/collections/realme-c75-5g-mobile-accessories-collection",
        },
        {
          name: "Gt 5g",
          url: "https://saleprice.in/collections/realme-gt-5g-mobile-accessories-collection",
        },
        {
          name: "Gt 7t",
          url: "https://saleprice.in/collections/realme-gt-7t-mobile-accessories-collection",
        },
        {
          name: "Gt Master",
          url: "https://saleprice.in/collections/realme-gt-master-mobile-accessories-collection",
        },
        {
          name: "Gt Neo 3t",
          url: "https://saleprice.in/collections/realme-gt-neo-3t-mobile-accessories-collection",
        },
        {
          name: "Gt Neo2",
          url: "https://saleprice.in/collections/realme-gt-neo2-mobile-accessories-collection",
        },
        {
          name: "Gt2",
          url: "https://saleprice.in/collections/realme-gt2-mobile-accessories-collection",
        },
        {
          name: "Gt2 Pro",
          url: "https://saleprice.in/collections/realme-gt2-pro-mobile-accessories-collection",
        },
        {
          name: "Gt6",
          url: "https://saleprice.in/collections/realme-gt6-mobile-accessories-collection",
        },
        {
          name: "Gt6t",
          url: "https://saleprice.in/collections/realme-gt6t-mobile-accessories-collection",
        },
        {
          name: "Gt7",
          url: "https://saleprice.in/collections/realme-gt7-mobile-accessories-collection",
        },
        {
          name: "N65",
          url: "https://saleprice.in/collections/realme-n65-mobile-accessories-collection",
        },
        {
          name: "Narzo 10",
          url: "https://saleprice.in/collections/realme-narzo-10-mobile-accessories-collection",
        },
        {
          name: "Narzo 10a",
          url: "https://saleprice.in/collections/realme-narzo-10a-mobile-accessories-collection",
        },
        {
          name: "Narzo 20",
          url: "https://saleprice.in/collections/realme-narzo-20-mobile-accessories-collection",
        },
        {
          name: "Narzo 20 Pro",
          url: "https://saleprice.in/collections/realme-narzo-20-pro-mobile-accessories-collection",
        },
        {
          name: "Narzo 20a",
          url: "https://saleprice.in/collections/realme-narzo-20a-mobile-accessories-collection",
        },
        {
          name: "Narzo 30 4g",
          url: "https://saleprice.in/collections/realme-narzo-30-4g-mobile-accessories-collection",
        },
        {
          name: "Narzo 30 5g",
          url: "https://saleprice.in/collections/realme-narzo-30-5g-mobile-accessories-collection",
        },
        {
          name: "Narzo 30 Pro",
          url: "https://saleprice.in/collections/realme-narzo-30-pro-mobile-accessories-collection",
        },
        {
          name: "Narzo 30a",
          url: "https://saleprice.in/collections/realme-narzo-30a-mobile-accessories-collection",
        },
        {
          name: "Narzo 50",
          url: "https://saleprice.in/collections/realme-narzo-50-mobile-accessories-collection",
        },
        {
          name: "Narzo 50a",
          url: "https://saleprice.in/collections/realme-narzo-50a-mobile-accessories-collection",
        },
        {
          name: "Narzo 50a Prime",
          url: "https://saleprice.in/collections/realme-narzo-50a-prime-mobile-accessories-collection",
        },
        {
          name: "Narzo 50a Prime 1",
          url: "https://saleprice.in/collections/realme-narzo-50a-prime-mobile-accessories-collection-1",
        },
        {
          name: "Narzo 50i",
          url: "https://saleprice.in/collections/realme-narzo-50i-mobile-accessories-collection",
        },
        {
          name: "Narzo 50i Prime",
          url: "https://saleprice.in/collections/realme-narzo-50i-prime-mobile-accessories-collection",
        },
        {
          name: "Narzo 60 Pro",
          url: "https://saleprice.in/collections/realme-narzo-60-pro-mobile-accessories-collection",
        },
        {
          name: "Narzo 60x 5g",
          url: "https://saleprice.in/collections/realme-narzo-60x-5g-mobile-accessories-collection",
        },
        {
          name: "Narzo 70 5g",
          url: "https://saleprice.in/collections/realme-narzo-70-5g-mobile-accessories-collection",
        },
        {
          name: "Narzo 70 Pro 5g",
          url: "https://saleprice.in/collections/realme-narzo-70-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Narzo 70x 5g",
          url: "https://saleprice.in/collections/realme-narzo-70x-5g-mobile-accessories-collection",
        },
        {
          name: "Narzo 80 Lite 5g",
          url: "https://saleprice.in/collections/realme-narzo-80-lite-5g-mobile-accessories-collection",
        },
        {
          name: "Narzo 80 Pro",
          url: "https://saleprice.in/collections/realme-narzo-80-pro-mobile-accessories-collection",
        },
        {
          name: "Narzo N53",
          url: "https://saleprice.in/collections/realme-narzo-n53-mobile-accessories-collection",
        },
        {
          name: "Narzo N55",
          url: "https://saleprice.in/collections/realme-narzo-n55-mobile-accessories-collection",
        },
        {
          name: "Narzo N61",
          url: "https://saleprice.in/collections/realme-narzo-n61-mobile-accessories-collection",
        },
        {
          name: "Narzo N63",
          url: "https://saleprice.in/collections/realme-narzo-n63-mobile-accessories-collection",
        },
        {
          name: "Narzo N65",
          url: "https://saleprice.in/collections/realme-narzo-n65-mobile-accessories-collection",
        },
        {
          name: "P1 5g",
          url: "https://saleprice.in/collections/realme-p1-5g-mobile-accessories-collection",
        },
        {
          name: "P2 Pro",
          url: "https://saleprice.in/collections/realme-p2-pro-mobile-accessories-collection",
        },
        {
          name: "P3",
          url: "https://saleprice.in/collections/realme-p3-mobile-accessories-collection",
        },
        {
          name: "P3 Pro",
          url: "https://saleprice.in/collections/realme-p3-pro-mobile-accessories-collection",
        },
        {
          name: "P3 Ultra",
          url: "https://saleprice.in/collections/realme-p3-ultra-mobile-accessories-collection",
        },
        {
          name: "P3x Pro",
          url: "https://saleprice.in/collections/realme-p3x-pro-mobile-accessories-collection",
        },
        {
          name: "Pad 10 4",
          url: "https://saleprice.in/collections/realme-pad-10-4-mobile-accessories-collection",
        },
        {
          name: "Pad Mini 8 7",
          url: "https://saleprice.in/collections/realme-pad-mini-8-7-mobile-accessories-collection",
        },
        {
          name: "U1",
          url: "https://saleprice.in/collections/realme-u1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "U1",
          url: "https://saleprice.in/collections/realme-u1-mobile-accessories-collection",
        },
        {
          name: "V25",
          url: "https://saleprice.in/collections/realme-v25-mobile-accessories-collection",
        },
        {
          name: "X",
          url: "https://saleprice.in/collections/realme-x-mobile-accessories-collection",
        },
        {
          name: "X2",
          url: "https://saleprice.in/collections/realme-x2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "X7",
          url: "https://saleprice.in/collections/realme-x7-mobile-accessories-collection",
        },
        {
          name: "X7 Max",
          url: "https://saleprice.in/collections/realme-x7-max-mobile-accessories-collection",
        },
        {
          name: "X7 Pro",
          url: "https://saleprice.in/collections/realme-x7-pro-mobile-accessories-collection",
        },
        {
          name: "Xt",
          url: "https://saleprice.in/collections/realme-xt-mobile-accessories-collection",
        },
      ],
      Redmi: [
        {
          name: "Note 10t 5g",
          url: "https://saleprice.in/collections/redmi-note-10t-5g-mobile-accessories-collection",
        },
      ],
      Samsung: [
        {
          name: "A01 Core",
          url: "https://saleprice.in/collections/samsung-a01-core-mobile-accessories-collection",
        },
        {
          name: "A02s",
          url: "https://saleprice.in/collections/samsung-a02s-mobile-accessories-collection",
        },
        {
          name: "A03",
          url: "https://saleprice.in/collections/samsung-a03-mobile-accessories-collection",
        },
        {
          name: "A03s",
          url: "https://saleprice.in/collections/samsung-a03s-mobile-accessories-collection",
        },
        {
          name: "A04",
          url: "https://saleprice.in/collections/samsung-a04-mobile-accessories-collection",
        },
        {
          name: "A04e",
          url: "https://saleprice.in/collections/samsung-a04e-mobile-accessories-collection",
        },
        {
          name: "A04s",
          url: "https://saleprice.in/collections/samsung-a04s-mobile-accessories-collection",
        },
        {
          name: "A05",
          url: "https://saleprice.in/collections/samsung-a05-mobile-accessories-collection",
        },
        {
          name: "A05s",
          url: "https://saleprice.in/collections/samsung-a05s-mobile-accessories-collection",
        },
        {
          name: "A11",
          url: "https://saleprice.in/collections/samsung-a11-mobile-accessories-collection",
        },
        {
          name: "A12",
          url: "https://saleprice.in/collections/samsung-a12-mobile-accessories-collection",
        },
        {
          name: "A13 4g",
          url: "https://saleprice.in/collections/samsung-a13-4g-mobile-accessories-collection",
        },
        {
          name: "A13 5g",
          url: "https://saleprice.in/collections/samsung-a13-5g-mobile-accessories-collection",
        },
        {
          name: "A14 4g",
          url: "https://saleprice.in/collections/samsung-a14-4g-mobile-accessories-collection",
        },
        {
          name: "A15",
          url: "https://saleprice.in/collections/samsung-a15-mobile-accessories-collection",
        },
        {
          name: "A15 5g",
          url: "https://saleprice.in/collections/samsung-a15-5g-mobile-accessories-collection",
        },
        {
          name: "A21 Imported",
          url: "https://saleprice.in/collections/samsung-a21-imported-mobile-accessories-collection",
        },
        {
          name: "A21s",
          url: "https://saleprice.in/collections/samsung-a21s-mobile-accessories-collection",
        },
        {
          name: "A22 4g",
          url: "https://saleprice.in/collections/samsung-a22-4g-mobile-accessories-collection",
        },
        {
          name: "A23",
          url: "https://saleprice.in/collections/samsung-a23-mobile-accessories-collection",
        },
        {
          name: "A24",
          url: "https://saleprice.in/collections/samsung-a24-mobile-accessories-collection",
        },
        {
          name: "A25 5g",
          url: "https://saleprice.in/collections/samsung-a25-5g-mobile-accessories-collection",
        },
        {
          name: "A31",
          url: "https://saleprice.in/collections/samsung-a31-mobile-accessories-collection",
        },
        {
          name: "A32 4g",
          url: "https://saleprice.in/collections/samsung-a32-4g-mobile-accessories-collection",
        },
        {
          name: "A33",
          url: "https://saleprice.in/collections/samsung-a33-mobile-accessories-collection",
        },
        {
          name: "A34 5g",
          url: "https://saleprice.in/collections/samsung-a34-5g-mobile-accessories-collection",
        },
        {
          name: "A35 5g",
          url: "https://saleprice.in/collections/samsung-a35-5g-mobile-accessories-collection",
        },
        {
          name: "A41",
          url: "https://saleprice.in/collections/samsung-a41-mobile-accessories-collection",
        },
        {
          name: "A42",
          url: "https://saleprice.in/collections/samsung-a42-mobile-accessories-collection",
        },
        {
          name: "A5 2016",
          url: "https://saleprice.in/collections/samsung-a5-2016-mobile-accessories-collection",
        },
        {
          name: "A5 6",
          url: "https://saleprice.in/collections/samsung-a5-6-mobile-accessories-collection",
        },
        {
          name: "A510",
          url: "https://saleprice.in/collections/samsung-a510-mobile-accessories-collection",
        },
        {
          name: "A52",
          url: "https://saleprice.in/collections/samsung-a52-mobile-accessories-collection",
        },
        {
          name: "A52 5g",
          url: "https://saleprice.in/collections/samsung-a52-5g-mobile-accessories-collection",
        },
        {
          name: "A52s 5g",
          url: "https://saleprice.in/collections/samsung-a52s-5g-mobile-accessories-collection",
        },
        {
          name: "A53",
          url: "https://saleprice.in/collections/samsung-a53-mobile-accessories-collection",
        },
        {
          name: "A55 5g 2mm",
          url: "https://saleprice.in/collections/samsung-a55-5g-transparent-soft-2mm-back-cover-mobile-accessories-collection",
        },
        {
          name: "A72",
          url: "https://saleprice.in/collections/samsung-a72-mobile-accessories-collection",
        },
        {
          name: "A73",
          url: "https://saleprice.in/collections/samsung-a73-mobile-accessories-collection",
        },
        {
          name: "C55 5g",
          url: "https://saleprice.in/collections/samsung-c55-5g-mobile-accessories-collection",
        },
        {
          name: "F02s",
          url: "https://saleprice.in/collections/samsung-f02s-mobile-accessories-collection",
        },
        {
          name: "F04",
          url: "https://saleprice.in/collections/samsung-f04-mobile-accessories-collection",
        },
        {
          name: "F05",
          url: "https://saleprice.in/collections/samsung-f05-mobile-accessories-collection",
        },
        {
          name: "F12",
          url: "https://saleprice.in/collections/samsung-f12-mobile-accessories-collection",
        },
        {
          name: "F13 4g 1",
          url: "https://saleprice.in/collections/samsung-f13-4g-mobile-accessories-collection-1",
        },
        {
          name: "F14",
          url: "https://saleprice.in/collections/samsung-f14-mobile-accessories-collection",
        },
        {
          name: "F15 5g",
          url: "https://saleprice.in/collections/samsung-f15-5g-mobile-accessories-collection",
        },
        {
          name: "F23 5g",
          url: "https://saleprice.in/collections/samsung-f23-5g-mobile-accessories-collection",
        },
        {
          name: "F34 5g 1",
          url: "https://saleprice.in/collections/samsung-f34-5g-mobile-accessories-collection-1",
        },
        {
          name: "F41",
          url: "https://saleprice.in/collections/samsung-f41-mobile-accessories-collection",
        },
        {
          name: "F55 5g",
          url: "https://saleprice.in/collections/samsung-f55-5g-mobile-accessories-collection",
        },
        {
          name: "F62",
          url: "https://saleprice.in/collections/samsung-f62-mobile-accessories-collection",
        },
        {
          name: "Galaxy 7106 Grand 2",
          url: "https://saleprice.in/collections/samsung-galaxy-7106-grand-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy 7562 Galaxy S Duos",
          url: "https://saleprice.in/collections/samsung-galaxy-7562-galaxy-s-duos-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A01",
          url: "https://saleprice.in/collections/samsung-galaxy-a01-mobile-accessories-collection",
        },
        {
          name: "Galaxy A02",
          url: "https://saleprice.in/collections/samsung-galaxy-a02-mobile-accessories-collection",
        },
        {
          name: "Galaxy A02 Core",
          url: "https://saleprice.in/collections/samsung-galaxy-a02-core-mobile-accessories-collection",
        },
        {
          name: "Galaxy A03 Core",
          url: "https://saleprice.in/collections/samsung-galaxy-a03-core-mobile-accessories-collection",
        },
        {
          name: "Galaxy A06",
          url: "https://saleprice.in/collections/samsung-galaxy-a06-mobile-accessories-collection",
        },
        {
          name: "Galaxy A07",
          url: "https://saleprice.in/collections/samsung-galaxy-a07-mobile-accessories-collection",
        },
        {
          name: "Galaxy A10",
          url: "https://saleprice.in/collections/samsung-galaxy-a10-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A10e",
          url: "https://saleprice.in/collections/samsung-galaxy-a10e-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A10s",
          url: "https://saleprice.in/collections/samsung-galaxy-a10s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A14 5g",
          url: "https://saleprice.in/collections/samsung-galaxy-a14-5g-mobile-accessories-collection",
        },
        {
          name: "Galaxy A16",
          url: "https://saleprice.in/collections/samsung-galaxy-a16-mobile-accessories-collection",
        },
        {
          name: "Galaxy A2 Core",
          url: "https://saleprice.in/collections/samsung-galaxy-a2-core-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A20",
          url: "https://saleprice.in/collections/samsung-galaxy-a20-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A20e",
          url: "https://saleprice.in/collections/samsung-galaxy-a20e-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A20s",
          url: "https://saleprice.in/collections/samsung-galaxy-a20s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A22 5g",
          url: "https://saleprice.in/collections/samsung-galaxy-a22-5g-mobile-accessories-collection",
        },
        {
          name: "Galaxy A23 5g",
          url: "https://saleprice.in/collections/samsung-galaxy-a23-5g-mobile-accessories-collection",
        },
        {
          name: "Galaxy A26",
          url: "https://saleprice.in/collections/samsung-galaxy-a26-mobile-accessories-collection",
        },
        {
          name: "Galaxy A30",
          url: "https://saleprice.in/collections/samsung-galaxy-a30-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A30s",
          url: "https://saleprice.in/collections/samsung-galaxy-a30s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A310 A3 2016",
          url: "https://saleprice.in/collections/samsung-galaxy-a310-a3-2016-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A32 5g",
          url: "https://saleprice.in/collections/samsung-galaxy-a32-5g-mobile-accessories-collection",
        },
        {
          name: "Galaxy A36",
          url: "https://saleprice.in/collections/samsung-galaxy-a36-mobile-accessories-collection",
        },
        {
          name: "Galaxy A40",
          url: "https://saleprice.in/collections/samsung-galaxy-a40-mobile-accessories-collection",
        },
        {
          name: "Galaxy A40s",
          url: "https://saleprice.in/collections/samsung-galaxy-a40s-mobile-accessories-collection",
        },
        {
          name: "Galaxy A5",
          url: "https://saleprice.in/collections/samsung-galaxy-a5-mobile-accessories-collection",
        },
        {
          name: "Galaxy A5 2015a500",
          url: "https://saleprice.in/collections/samsung-galaxy-a5-2015a500-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A5 2016 A5 6a510",
          url: "https://saleprice.in/collections/samsung-galaxy-a5-2016-a5-6a510-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A5 2017 A5 7a520",
          url: "https://saleprice.in/collections/samsung-galaxy-a5-2017-a5-7a520-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A50",
          url: "https://saleprice.in/collections/samsung-galaxy-a50-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A50 1",
          url: "https://saleprice.in/collections/samsung-galaxy-a50-back-cover-tempered-glass-and-other-mobile-accessories-collection-1",
        },
        {
          name: "Galaxy A51",
          url: "https://saleprice.in/collections/samsung-galaxy-a51-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A54 5g",
          url: "https://saleprice.in/collections/samsung-galaxy-a54-5g-mobile-accessories-collection",
        },
        {
          name: "Galaxy A56",
          url: "https://saleprice.in/collections/samsung-galaxy-a56-mobile-accessories-collection",
        },
        {
          name: "Galaxy A6",
          url: "https://saleprice.in/collections/samsung-galaxy-a6-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A6 Plus",
          url: "https://saleprice.in/collections/samsung-galaxy-a6-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A60",
          url: "https://saleprice.in/collections/samsung-galaxy-a60-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A7",
          url: "https://saleprice.in/collections/samsung-galaxy-a7-mobile-accessories-collection",
        },
        {
          name: "Galaxy A7 2015a700",
          url: "https://saleprice.in/collections/samsung-galaxy-a7-2015a700-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A7 2018",
          url: "https://saleprice.in/collections/samsung-galaxy-a7-2018-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A7 6 A7 2016a710",
          url: "https://saleprice.in/collections/samsung-galaxy-a7-6-a7-2016a710-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A7 7 A7 2017a720",
          url: "https://saleprice.in/collections/samsung-galaxy-a7-7-a7-2017a720-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A70",
          url: "https://saleprice.in/collections/samsung-galaxy-a70-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A70s",
          url: "https://saleprice.in/collections/samsung-galaxy-a70s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A71",
          url: "https://saleprice.in/collections/samsung-galaxy-a71-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A750",
          url: "https://saleprice.in/collections/samsung-galaxy-a750-mobile-accessories-collection",
        },
        {
          name: "Galaxy A8",
          url: "https://saleprice.in/collections/samsung-galaxy-a8-mobile-accessories-collection",
        },
        {
          name: "Galaxy A8 Plus",
          url: "https://saleprice.in/collections/samsung-galaxy-a8-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A8 Star",
          url: "https://saleprice.in/collections/samsung-galaxy-a8-star-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A80",
          url: "https://saleprice.in/collections/samsung-galaxy-a80-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A9 2018",
          url: "https://saleprice.in/collections/samsung-galaxy-a9-2018-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A9 Pro",
          url: "https://saleprice.in/collections/samsung-galaxy-a9-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy A91",
          url: "https://saleprice.in/collections/samsung-galaxy-a91-mobile-accessories-collection",
        },
        {
          name: "Galaxy C7 Pro",
          url: "https://saleprice.in/collections/samsung-galaxy-c7-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy C9 Pro",
          url: "https://saleprice.in/collections/samsung-galaxy-c9-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy Core 2 G355h",
          url: "https://saleprice.in/collections/samsung-galaxy-core-2-g355h-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy E5",
          url: "https://saleprice.in/collections/samsung-galaxy-e5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy E7",
          url: "https://saleprice.in/collections/samsung-galaxy-e7-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy F06",
          url: "https://saleprice.in/collections/samsung-galaxy-f06-mobile-accessories-collection",
        },
        {
          name: "Galaxy F14 5g",
          url: "https://saleprice.in/collections/samsung-galaxy-f14-5g-mobile-accessories-collection",
        },
        {
          name: "Galaxy F16",
          url: "https://saleprice.in/collections/samsung-galaxy-f16-mobile-accessories-collection",
        },
        {
          name: "Galaxy F17",
          url: "https://saleprice.in/collections/samsung-galaxy-f17-mobile-accessories-collection",
        },
        {
          name: "Galaxy F54 5g",
          url: "https://saleprice.in/collections/samsung-galaxy-f54-5g-mobile-accessories-collection",
        },
        {
          name: "Galaxy F56",
          url: "https://saleprice.in/collections/samsung-galaxy-f56-mobile-accessories-collection",
        },
        {
          name: "Galaxy Fold 6",
          url: "https://saleprice.in/collections/samsung-galaxy-fold-6-mobile-accessories-collection",
        },
        {
          name: "Galaxy Grand I9082",
          url: "https://saleprice.in/collections/samsung-galaxy-grand-i9082-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy Grand Max 7202",
          url: "https://saleprice.in/collections/samsung-galaxy-grand-max-7202-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy Grand Prime G530",
          url: "https://saleprice.in/collections/samsung-galaxy-grand-prime-g530-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J1 Ace",
          url: "https://saleprice.in/collections/samsung-galaxy-j1-ace-mobile-accessories-collection",
        },
        {
          name: "Galaxy J2 2015",
          url: "https://saleprice.in/collections/samsung-galaxy-j2-2015-mobile-accessories-collection",
        },
        {
          name: "Galaxy J2 2016",
          url: "https://saleprice.in/collections/samsung-galaxy-j2-2016-mobile-accessories-collection",
        },
        {
          name: "Galaxy J2 2018",
          url: "https://saleprice.in/collections/samsung-galaxy-j2-2018-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J2 Ace",
          url: "https://saleprice.in/collections/samsung-galaxy-j2-ace-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J2 Core",
          url: "https://saleprice.in/collections/samsung-galaxy-j2-core-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J2 J200",
          url: "https://saleprice.in/collections/samsung-galaxy-j2-j200-mobile-accessories-collection",
        },
        {
          name: "Galaxy J2 Pro",
          url: "https://saleprice.in/collections/samsung-galaxy-j2-pro-mobile-accessories-collection",
        },
        {
          name: "Galaxy J210",
          url: "https://saleprice.in/collections/samsung-galaxy-j210-mobile-accessories-collection",
        },
        {
          name: "Galaxy J3",
          url: "https://saleprice.in/collections/samsung-galaxy-j3-mobile-accessories-collection",
        },
        {
          name: "Galaxy J3 Pro",
          url: "https://saleprice.in/collections/samsung-galaxy-j3-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J4",
          url: "https://saleprice.in/collections/samsung-galaxy-j4-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J4 Plus",
          url: "https://saleprice.in/collections/samsung-galaxy-j4-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J5 6 J5 2016j510",
          url: "https://saleprice.in/collections/samsung-galaxy-j5-6-j5-2016j510-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J6",
          url: "https://saleprice.in/collections/samsung-galaxy-j6-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J6 Plus",
          url: "https://saleprice.in/collections/samsung-galaxy-j6-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J7",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-mobile-accessories-collection",
        },
        {
          name: "Galaxy J7 6 J7 2016j710",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-6-j7-2016j710-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J7 Duo",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-duo-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J7 Edge",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-edge-mobile-accessories-collection",
        },
        {
          name: "Galaxy J7 J7 Nxt",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-j7-nxt-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J7 Max",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-max-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J7 Max 1",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-max-back-cover-tempered-glass-and-other-mobile-accessories-collection-1",
        },
        {
          name: "Galaxy J7 Nxt",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-nxt-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J7 Nxt 2",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-nxt-mobile-accessories-collection-2",
        },
        {
          name: "Galaxy J7 Prime",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-prime-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J7 Prime 1",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-prime-back-cover-tempered-glass-and-other-mobile-accessories-collection-1",
        },
        {
          name: "Galaxy J7 Pro",
          url: "https://saleprice.in/collections/samsung-galaxy-j7-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy J8 2018",
          url: "https://saleprice.in/collections/samsung-galaxy-j8-2018-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy M01s",
          url: "https://saleprice.in/collections/samsung-galaxy-m01s-mobile-accessories-collection",
        },
        {
          name: "Galaxy M06",
          url: "https://saleprice.in/collections/samsung-galaxy-m06-mobile-accessories-collection",
        },
        {
          name: "Galaxy M10",
          url: "https://saleprice.in/collections/samsung-galaxy-m10-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy M10s",
          url: "https://saleprice.in/collections/samsung-galaxy-m10s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy M13",
          url: "https://saleprice.in/collections/samsung-galaxy-m13-mobile-accessories-collection",
        },
        {
          name: "Galaxy M16",
          url: "https://saleprice.in/collections/samsung-galaxy-m16-mobile-accessories-collection",
        },
        {
          name: "Galaxy M20",
          url: "https://saleprice.in/collections/samsung-galaxy-m20-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy M21 2021",
          url: "https://saleprice.in/collections/samsung-galaxy-m21-2021-mobile-accessories-collection",
        },
        {
          name: "Galaxy M21s",
          url: "https://saleprice.in/collections/samsung-galaxy-m21s-mobile-accessories-collection",
        },
        {
          name: "Galaxy M30",
          url: "https://saleprice.in/collections/samsung-galaxy-m30-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy M30s",
          url: "https://saleprice.in/collections/samsung-galaxy-m30s-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy M31",
          url: "https://saleprice.in/collections/samsung-galaxy-m31-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy M32 5g",
          url: "https://saleprice.in/collections/samsung-galaxy-m32-5g-mobile-accessories-collection",
        },
        {
          name: "Galaxy M35",
          url: "https://saleprice.in/collections/samsung-galaxy-m35-mobile-accessories-collection",
        },
        {
          name: "Galaxy M36",
          url: "https://saleprice.in/collections/samsung-galaxy-m36-mobile-accessories-collection",
        },
        {
          name: "Galaxy M40",
          url: "https://saleprice.in/collections/samsung-galaxy-m40-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy M50",
          url: "https://saleprice.in/collections/samsung-galaxy-m50-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy M56",
          url: "https://saleprice.in/collections/samsung-galaxy-m56-mobile-accessories-collection",
        },
        {
          name: "Galaxy Note 10",
          url: "https://saleprice.in/collections/samsung-galaxy-note-10-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy Note 10 Lite",
          url: "https://saleprice.in/collections/samsung-galaxy-note-10-lite-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy Note 10 Plus",
          url: "https://saleprice.in/collections/samsung-galaxy-note-10-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy Note 3",
          url: "https://saleprice.in/collections/samsung-galaxy-note-3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy Note 4",
          url: "https://saleprice.in/collections/samsung-galaxy-note-4-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy Note 5",
          url: "https://saleprice.in/collections/samsung-galaxy-note-5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy Note 8",
          url: "https://saleprice.in/collections/samsung-galaxy-note-8-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy Note 9",
          url: "https://saleprice.in/collections/samsung-galaxy-note-9-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy On 5",
          url: "https://saleprice.in/collections/samsung-galaxy-on-5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy On 7",
          url: "https://saleprice.in/collections/samsung-galaxy-on-7-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy On 8 2018 1",
          url: "https://saleprice.in/collections/samsung-galaxy-on-8-2018-mobile-accessories-collection-1",
        },
        {
          name: "Galaxy On Max",
          url: "https://saleprice.in/collections/samsung-galaxy-on-max-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy On Nxt",
          url: "https://saleprice.in/collections/samsung-galaxy-on-nxt-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy On7 Prime",
          url: "https://saleprice.in/collections/samsung-galaxy-on7-prime-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S10",
          url: "https://saleprice.in/collections/samsung-galaxy-s10-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S10 Lite",
          url: "https://saleprice.in/collections/samsung-galaxy-s10-lite-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S10 Plus",
          url: "https://saleprice.in/collections/samsung-galaxy-s10-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S10e",
          url: "https://saleprice.in/collections/samsung-galaxy-s10e-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S20",
          url: "https://saleprice.in/collections/samsung-galaxy-s20-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S20 Plus",
          url: "https://saleprice.in/collections/samsung-galaxy-s20-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S20 Ultra",
          url: "https://saleprice.in/collections/samsung-galaxy-s20-ultra-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S24 Fe",
          url: "https://saleprice.in/collections/samsung-galaxy-s24-fe-mobile-accessories-collection",
        },
        {
          name: "Galaxy S25",
          url: "https://saleprice.in/collections/samsung-galaxy-s25-mobile-accessories-collection",
        },
        {
          name: "Galaxy S25 Edge",
          url: "https://saleprice.in/collections/samsung-galaxy-s25-edge-mobile-accessories-collection",
        },
        {
          name: "Galaxy S25 Fe",
          url: "https://saleprice.in/collections/samsung-galaxy-s25-fe-mobile-accessories-collection",
        },
        {
          name: "Galaxy S25 Plus",
          url: "https://saleprice.in/collections/samsung-galaxy-s25-plus-mobile-accessories-collection",
        },
        {
          name: "Galaxy S25 Ultra",
          url: "https://saleprice.in/collections/samsung-galaxy-s25-ultra-mobile-accessories-collection",
        },
        {
          name: "Galaxy S3",
          url: "https://saleprice.in/collections/samsung-galaxy-s3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S30",
          url: "https://saleprice.in/collections/samsung-galaxy-s30-mobile-accessories-collection",
        },
        {
          name: "Galaxy S4",
          url: "https://saleprice.in/collections/samsung-galaxy-s4-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S5",
          url: "https://saleprice.in/collections/samsung-galaxy-s5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S6 Edge",
          url: "https://saleprice.in/collections/samsung-galaxy-s6-edge-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S7",
          url: "https://saleprice.in/collections/samsung-galaxy-s7-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S7 Edge",
          url: "https://saleprice.in/collections/samsung-galaxy-s7-edge-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S8",
          url: "https://saleprice.in/collections/samsung-galaxy-s8-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S8 Plus",
          url: "https://saleprice.in/collections/samsung-galaxy-s8-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S9",
          url: "https://saleprice.in/collections/samsung-galaxy-s9-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy S9 Plus",
          url: "https://saleprice.in/collections/samsung-galaxy-s9-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy T111 3v",
          url: "https://saleprice.in/collections/samsung-galaxy-t111-3v-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Galaxy Tab A8 X200",
          url: "https://saleprice.in/collections/samsung-galaxy-tab-a8-x200-mobile-accessories-collection",
        },
        {
          name: "Galaxy Tab A8 X205",
          url: "https://saleprice.in/collections/samsung-galaxy-tab-a8-x205-mobile-accessories-collection",
        },
        {
          name: "J Max T285",
          url: "https://saleprice.in/collections/samsung-j-max-t285-mobile-accessories-collection",
        },
        {
          name: "M01",
          url: "https://saleprice.in/collections/samsung-m01-mobile-accessories-collection",
        },
        {
          name: "M01 Core",
          url: "https://saleprice.in/collections/samsung-m01-core-mobile-accessories-collection",
        },
        {
          name: "M02",
          url: "https://saleprice.in/collections/samsung-m02-mobile-accessories-collection",
        },
        {
          name: "M02s",
          url: "https://saleprice.in/collections/samsung-m02s-mobile-accessories-collection",
        },
        {
          name: "M04",
          url: "https://saleprice.in/collections/samsung-m04-mobile-accessories-collection",
        },
        {
          name: "M05",
          url: "https://saleprice.in/collections/samsung-m05-mobile-accessories-collection",
        },
        {
          name: "M11",
          url: "https://saleprice.in/collections/samsung-m11-mobile-accessories-collection",
        },
        {
          name: "M12",
          url: "https://saleprice.in/collections/samsung-m12-mobile-accessories-collection",
        },
        {
          name: "M13 5g",
          url: "https://saleprice.in/collections/samsung-m13-5g-mobile-accessories-collection",
        },
        {
          name: "M14 5g",
          url: "https://saleprice.in/collections/samsung-m14-5g-mobile-accessories-collection",
        },
        {
          name: "M15 5g",
          url: "https://saleprice.in/collections/samsung-m15-5g-mobile-accessories-collection",
        },
        {
          name: "M21 5g",
          url: "https://saleprice.in/collections/samsung-m21-5g-mobile-accessories-collection",
        },
        {
          name: "M23 5g",
          url: "https://saleprice.in/collections/samsung-m23-5g-mobile-accessories-collection",
        },
        {
          name: "M31s",
          url: "https://saleprice.in/collections/samsung-m31s-mobile-accessories-collection",
        },
        {
          name: "M32 4g",
          url: "https://saleprice.in/collections/samsung-m32-4g-mobile-accessories-collection",
        },
        {
          name: "M33",
          url: "https://saleprice.in/collections/samsung-m33-mobile-accessories-collection",
        },
        {
          name: "M34 5g 2mm",
          url: "https://saleprice.in/collections/samsung-m34-5g-transparent-soft-2mm-back-cover-mobile-accessories-collection",
        },
        {
          name: "M42",
          url: "https://saleprice.in/collections/samsung-m42-mobile-accessories-collection",
        },
        {
          name: "M51",
          url: "https://saleprice.in/collections/samsung-m51-mobile-accessories-collection",
        },
        {
          name: "M52",
          url: "https://saleprice.in/collections/samsung-m52-mobile-accessories-collection",
        },
        {
          name: "M53",
          url: "https://saleprice.in/collections/samsung-m53-mobile-accessories-collection",
        },
        {
          name: "M54 5g",
          url: "https://saleprice.in/collections/samsung-m54-5g-mobile-accessories-collection",
        },
        {
          name: "M55 5g",
          url: "https://saleprice.in/collections/samsung-m55-5g-mobile-accessories-collection",
        },
        {
          name: "M55s",
          url: "https://saleprice.in/collections/samsung-m55s-mobile-accessories-collection",
        },
        {
          name: "M62",
          url: "https://saleprice.in/collections/samsung-m62-mobile-accessories-collection",
        },
        {
          name: "Note 20",
          url: "https://saleprice.in/collections/samsung-note-20-mobile-accessories-collection",
        },
        {
          name: "Note 20 Plus",
          url: "https://saleprice.in/collections/samsung-note-20-plus-mobile-accessories-collection",
        },
        {
          name: "Note 20 Ultra",
          url: "https://saleprice.in/collections/samsung-note-20-ultra-mobile-accessories-collection",
        },
        {
          name: "S20 Fe",
          url: "https://saleprice.in/collections/samsung-s20-fe-mobile-accessories-collection",
        },
        {
          name: "S21",
          url: "https://saleprice.in/collections/samsung-s21-mobile-accessories-collection",
        },
        {
          name: "S21 Fe",
          url: "https://saleprice.in/collections/samsung-s21-fe-mobile-accessories-collection",
        },
        {
          name: "S21 Plus",
          url: "https://saleprice.in/collections/samsung-s21-plus-mobile-accessories-collection",
        },
        {
          name: "S21 S30",
          url: "https://saleprice.in/collections/samsung-s21-s30-mobile-accessories-collection",
        },
        {
          name: "S21 Ultra",
          url: "https://saleprice.in/collections/samsung-s21-ultra-mobile-accessories-collection",
        },
        {
          name: "S22",
          url: "https://saleprice.in/collections/samsung-s22-mobile-accessories-collection",
        },
        {
          name: "S22 Plus",
          url: "https://saleprice.in/collections/samsung-s22-plus-mobile-accessories-collection",
        },
        {
          name: "S22 Ultra",
          url: "https://saleprice.in/collections/samsung-s22-ultra-mobile-accessories-collection",
        },
        {
          name: "S23",
          url: "https://saleprice.in/collections/samsung-s23-mobile-accessories-collection",
        },
        {
          name: "S23 Fe",
          url: "https://saleprice.in/collections/samsung-s23-fe-mobile-accessories-collection",
        },
        {
          name: "S23 Plus",
          url: "https://saleprice.in/collections/samsung-s23-plus-mobile-accessories-collection",
        },
        {
          name: "S23 Ultra",
          url: "https://saleprice.in/collections/samsung-s23-ultra-mobile-accessories-collection",
        },
        {
          name: "S23fe Ultra 2mm",
          url: "https://saleprice.in/collections/samsung-s23fe-ultra-transparent-soft-2mm-back-cover-mobile-accessories-collection",
        },
        {
          name: "S24",
          url: "https://saleprice.in/collections/samsung-s24-mobile-accessories-collection",
        },
        {
          name: "S24 Plus",
          url: "https://saleprice.in/collections/samsung-s24-plus-mobile-accessories-collection",
        },
        {
          name: "S24 Ultra",
          url: "https://saleprice.in/collections/samsung-s24-ultra-mobile-accessories-collection",
        },
        {
          name: "Tizen Z2",
          url: "https://saleprice.in/collections/samsung-tizen-z2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Tizen Z3",
          url: "https://saleprice.in/collections/samsung-tizen-z3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
      Sony: [
        {
          name: "M4",
          url: "https://saleprice.in/collections/sony-m4-mobile-accessories-collection",
        },
        {
          name: "Xperia C5",
          url: "https://saleprice.in/collections/sony-xperia-c5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Xperia C5 Ultra",
          url: "https://saleprice.in/collections/sony-xperia-c5-ultra-mobile-accessories-collection",
        },
        {
          name: "Xperia M4 Aqua",
          url: "https://saleprice.in/collections/sony-xperia-m4-aqua-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Xperia T2 Ultra",
          url: "https://saleprice.in/collections/sony-xperia-t2-ultra-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Xperia Xa",
          url: "https://saleprice.in/collections/sony-xperia-xa-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Xperia Xa Ultra",
          url: "https://saleprice.in/collections/sony-xperia-xa-ultra-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
      Tecno: [
        {
          name: "Camon 19",
          url: "https://saleprice.in/collections/tecno-camon-19-mobile-accessories-collection",
        },
        {
          name: "Camon 19 Pro",
          url: "https://saleprice.in/collections/tecno-camon-19-pro-mobile-accessories-collection",
        },
        {
          name: "Camon Ace",
          url: "https://saleprice.in/collections/tecno-camon-ace-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Camon Sky 2",
          url: "https://saleprice.in/collections/tecno-camon-sky-2-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Pop 5 Pro",
          url: "https://saleprice.in/collections/tecno-pop-5-pro-mobile-accessories-collection",
        },
        {
          name: "Pop 8",
          url: "https://saleprice.in/collections/tecno-pop-8-mobile-accessories-collection",
        },
        {
          name: "Pop 9 4g",
          url: "https://saleprice.in/collections/tecno-pop-9-4g-mobile-accessories-collection",
        },
        {
          name: "Pova",
          url: "https://saleprice.in/collections/tecno-pova-mobile-accessories-collection",
        },
        {
          name: "Pova 2",
          url: "https://saleprice.in/collections/tecno-pova-2-mobile-accessories-collection",
        },
        {
          name: "Pova 6 Neo",
          url: "https://saleprice.in/collections/tecno-pova-6-neo-mobile-accessories-collection",
        },
        {
          name: "Pova 6 Neo 5g",
          url: "https://saleprice.in/collections/tecno-pova-6-neo-5g-mobile-accessories-collection",
        },
        {
          name: "Pova 7 5g",
          url: "https://saleprice.in/collections/tecno-pova-7-5g-mobile-accessories-collection",
        },
        {
          name: "Spark 20 Pro",
          url: "https://saleprice.in/collections/tecno-spark-20-pro-mobile-accessories-collection",
        },
        {
          name: "Spark 40 Pro",
          url: "https://saleprice.in/collections/tecno-spark-40-pro-mobile-accessories-collection",
        },
        {
          name: "Spark 6",
          url: "https://saleprice.in/collections/tecno-spark-6-mobile-accessories-collection",
        },
        {
          name: "Spark 6 Air",
          url: "https://saleprice.in/collections/tecno-spark-6-air-mobile-accessories-collection",
        },
        {
          name: "Spark 6 Go",
          url: "https://saleprice.in/collections/tecno-spark-6-go-mobile-accessories-collection",
        },
        {
          name: "Spark Go",
          url: "https://saleprice.in/collections/tecno-spark-go-mobile-accessories-collection",
        },
        {
          name: "Spark Go 2020",
          url: "https://saleprice.in/collections/tecno-spark-go-2020-mobile-accessories-collection",
        },
        {
          name: "Spark Go 2022",
          url: "https://saleprice.in/collections/tecno-spark-go-2022-mobile-accessories-collection",
        },
        {
          name: "Spark Go 2023 1",
          url: "https://saleprice.in/collections/tecno-spark-go-2023-mobile-accessories-collection-1",
        },
        {
          name: "Spark Go 2024",
          url: "https://saleprice.in/collections/tecno-spark-go-2024-mobile-accessories-collection",
        },
        {
          name: "Spark Power 2",
          url: "https://saleprice.in/collections/tecno-spark-power-2-mobile-accessories-collection",
        },
      ],
      Vivo: [
        {
          name: "S1",
          url: "https://saleprice.in/collections/vivo-s1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "S1 Pro",
          url: "https://saleprice.in/collections/vivo-s1-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "S17 Pro",
          url: "https://saleprice.in/collections/vivo-s17-pro-mobile-accessories-collection",
        },
        {
          name: "T1 44w",
          url: "https://saleprice.in/collections/vivo-t1-44w-mobile-accessories-collection",
        },
        {
          name: "T1 5g",
          url: "https://saleprice.in/collections/vivo-t1-5g-mobile-accessories-collection",
        },
        {
          name: "T1 Pro",
          url: "https://saleprice.in/collections/vivo-t1-pro-mobile-accessories-collection",
        },
        {
          name: "T2 5g",
          url: "https://saleprice.in/collections/vivo-t2-5g-mobile-accessories-collection",
        },
        {
          name: "T2 Pro 5g",
          url: "https://saleprice.in/collections/vivo-t2-pro-5g-mobile-accessories-collection",
        },
        {
          name: "T2x 5g",
          url: "https://saleprice.in/collections/vivo-t2x-5g-mobile-accessories-collection",
        },
        {
          name: "T3 Lite 2",
          url: "https://saleprice.in/collections/vivo-t3-lite-mobile-accessories-collection-2",
        },
        {
          name: "T3 Pro",
          url: "https://saleprice.in/collections/vivo-t3-pro-mobile-accessories-collection",
        },
        {
          name: "T3x",
          url: "https://saleprice.in/collections/vivo-t3x-mobile-accessories-collection",
        },
        {
          name: "T4 Ultra",
          url: "https://saleprice.in/collections/vivo-t4-ultra-mobile-accessories-collection",
        },
        {
          name: "T4x",
          url: "https://saleprice.in/collections/vivo-t4x-mobile-accessories-collection",
        },
        {
          name: "U10",
          url: "https://saleprice.in/collections/vivo-u10-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "U20",
          url: "https://saleprice.in/collections/vivo-u20-mobile-accessories-collection",
        },
        {
          name: "V1",
          url: "https://saleprice.in/collections/vivo-v1-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V11",
          url: "https://saleprice.in/collections/vivo-v11-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V11 Pro",
          url: "https://saleprice.in/collections/vivo-v11-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V11i",
          url: "https://saleprice.in/collections/vivo-v11i-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V15",
          url: "https://saleprice.in/collections/vivo-v15-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V15 Pro",
          url: "https://saleprice.in/collections/vivo-v15-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V17",
          url: "https://saleprice.in/collections/vivo-v17-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V17 Pro",
          url: "https://saleprice.in/collections/vivo-v17-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V19",
          url: "https://saleprice.in/collections/vivo-v19-mobile-accessories-collection",
        },
        {
          name: "V20",
          url: "https://saleprice.in/collections/vivo-v20-mobile-accessories-collection",
        },
        {
          name: "V20 Pro",
          url: "https://saleprice.in/collections/vivo-v20-pro-mobile-accessories-collection",
        },
        {
          name: "V20se",
          url: "https://saleprice.in/collections/vivo-v20se-mobile-accessories-collection",
        },
        {
          name: "V21",
          url: "https://saleprice.in/collections/vivo-v21-mobile-accessories-collection",
        },
        {
          name: "V21e",
          url: "https://saleprice.in/collections/vivo-v21e-mobile-accessories-collection",
        },
        {
          name: "V21e 5g",
          url: "https://saleprice.in/collections/vivo-v21e-5g-mobile-accessories-collection",
        },
        {
          name: "V23",
          url: "https://saleprice.in/collections/vivo-v23-mobile-accessories-collection",
        },
        {
          name: "V23 Pro",
          url: "https://saleprice.in/collections/vivo-v23-pro-mobile-accessories-collection",
        },
        {
          name: "V23e",
          url: "https://saleprice.in/collections/vivo-v23e-mobile-accessories-collection",
        },
        {
          name: "V23e 5g",
          url: "https://saleprice.in/collections/vivo-v23e-5g-mobile-accessories-collection",
        },
        {
          name: "V25",
          url: "https://saleprice.in/collections/vivo-v25-mobile-accessories-collection",
        },
        {
          name: "V25 Pro",
          url: "https://saleprice.in/collections/vivo-v25-pro-mobile-accessories-collection",
        },
        {
          name: "V27",
          url: "https://saleprice.in/collections/vivo-v27-mobile-accessories-collection",
        },
        {
          name: "V27 Pro",
          url: "https://saleprice.in/collections/vivo-v27-pro-mobile-accessories-collection",
        },
        {
          name: "V29",
          url: "https://saleprice.in/collections/vivo-v29-mobile-accessories-collection",
        },
        {
          name: "V29 1",
          url: "https://saleprice.in/collections/vivo-v29-mobile-accessories-collection-1",
        },
        {
          name: "V29 E",
          url: "https://saleprice.in/collections/vivo-v29-e-mobile-accessories-collection",
        },
        {
          name: "V29 Pro",
          url: "https://saleprice.in/collections/vivo-v29-pro-mobile-accessories-collection",
        },
        {
          name: "V3",
          url: "https://saleprice.in/collections/vivo-v3-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V3 Max",
          url: "https://saleprice.in/collections/vivo-v3-max-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V30",
          url: "https://saleprice.in/collections/vivo-v30-mobile-accessories-collection",
        },
        {
          name: "V30 Pro",
          url: "https://saleprice.in/collections/vivo-v30-pro-mobile-accessories-collection",
        },
        {
          name: "V30e",
          url: "https://saleprice.in/collections/vivo-v30e-mobile-accessories-collection",
        },
        {
          name: "V40",
          url: "https://saleprice.in/collections/vivo-v40-mobile-accessories-collection",
        },
        {
          name: "V40 Pro",
          url: "https://saleprice.in/collections/vivo-v40-pro-mobile-accessories-collection",
        },
        {
          name: "V40e",
          url: "https://saleprice.in/collections/vivo-v40e-mobile-accessories-collection",
        },
        {
          name: "V5",
          url: "https://saleprice.in/collections/vivo-v5-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V5 Plus",
          url: "https://saleprice.in/collections/vivo-v5-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V50",
          url: "https://saleprice.in/collections/vivo-v50-mobile-accessories-collection",
        },
        {
          name: "V7",
          url: "https://saleprice.in/collections/vivo-v7-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V7 Plus",
          url: "https://saleprice.in/collections/vivo-v7-plus-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V9",
          url: "https://saleprice.in/collections/vivo-v9-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "V9 Youth",
          url: "https://saleprice.in/collections/vivo-v9-youth-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "X100",
          url: "https://saleprice.in/collections/vivo-x100-mobile-accessories-collection",
        },
        {
          name: "X100 Pro",
          url: "https://saleprice.in/collections/vivo-x100-pro-mobile-accessories-collection",
        },
        {
          name: "X200",
          url: "https://saleprice.in/collections/vivo-x200-mobile-accessories-collection",
        },
        {
          name: "X200 Fe",
          url: "https://saleprice.in/collections/vivo-x200-fe-mobile-accessories-collection",
        },
        {
          name: "X200 Pro",
          url: "https://saleprice.in/collections/vivo-x200-pro-mobile-accessories-collection",
        },
        {
          name: "X21",
          url: "https://saleprice.in/collections/vivo-x21-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "X50",
          url: "https://saleprice.in/collections/vivo-x50-mobile-accessories-collection",
        },
        {
          name: "X60",
          url: "https://saleprice.in/collections/vivo-x60-mobile-accessories-collection",
        },
        {
          name: "X60 Pro",
          url: "https://saleprice.in/collections/vivo-x60-pro-mobile-accessories-collection",
        },
        {
          name: "X70",
          url: "https://saleprice.in/collections/vivo-x70-mobile-accessories-collection",
        },
        {
          name: "X70 Pro Plus",
          url: "https://saleprice.in/collections/vivo-x70-pro-plus-mobile-accessories-collection",
        },
        {
          name: "X80 5g",
          url: "https://saleprice.in/collections/vivo-x80-5g-mobile-accessories-collection",
        },
        {
          name: "X80 Pro",
          url: "https://saleprice.in/collections/vivo-x80-pro-mobile-accessories-collection",
        },
        {
          name: "X90 5g",
          url: "https://saleprice.in/collections/vivo-x90-5g-mobile-accessories-collection",
        },
        {
          name: "X90 Pro",
          url: "https://saleprice.in/collections/vivo-x90-pro-mobile-accessories-collection",
        },
        {
          name: "X90 Pro 5g",
          url: "https://saleprice.in/collections/vivo-x90-pro-5g-mobile-accessories-collection",
        },
        {
          name: "Y01",
          url: "https://saleprice.in/collections/vivo-y01-mobile-accessories-collection",
        },
        {
          name: "Y02",
          url: "https://saleprice.in/collections/vivo-y02-mobile-accessories-collection",
        },
        {
          name: "Y02s",
          url: "https://saleprice.in/collections/vivo-y02s-mobile-accessories-collection",
        },
        {
          name: "Y03",
          url: "https://saleprice.in/collections/vivo-y03-mobile-accessories-collection",
        },
        {
          name: "Y04",
          url: "https://saleprice.in/collections/vivo-y04-mobile-accessories-collection",
        },
        {
          name: "Y100 5g",
          url: "https://saleprice.in/collections/vivo-y100-5g-mobile-accessories-collection",
        },
        {
          name: "Y11 2019",
          url: "https://saleprice.in/collections/vivo-y11-2019-mobile-accessories-collection",
        },
        {
          name: "Y12",
          url: "https://saleprice.in/collections/vivo-y12-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y12s",
          url: "https://saleprice.in/collections/vivo-y12s-mobile-accessories-collection",
        },
        {
          name: "Y15",
          url: "https://saleprice.in/collections/vivo-y15-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y15s",
          url: "https://saleprice.in/collections/vivo-y15s-mobile-accessories-collection",
        },
        {
          name: "Y16",
          url: "https://saleprice.in/collections/vivo-y16-mobile-accessories-collection",
        },
        {
          name: "Y17",
          url: "https://saleprice.in/collections/vivo-y17-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y17s",
          url: "https://saleprice.in/collections/vivo-y17s-mobile-accessories-collection",
        },
        {
          name: "Y18",
          url: "https://saleprice.in/collections/vivo-y18-mobile-accessories-collection",
        },
        {
          name: "Y18e",
          url: "https://saleprice.in/collections/vivo-y18e-mobile-accessories-collection",
        },
        {
          name: "Y18i",
          url: "https://saleprice.in/collections/vivo-y18i-mobile-accessories-collection",
        },
        {
          name: "Y18t",
          url: "https://saleprice.in/collections/vivo-y18t-mobile-accessories-collection",
        },
        {
          name: "Y19",
          url: "https://saleprice.in/collections/vivo-y19-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y20",
          url: "https://saleprice.in/collections/vivo-y20-mobile-accessories-collection",
        },
        {
          name: "Y200",
          url: "https://saleprice.in/collections/vivo-y200-mobile-accessories-collection",
        },
        {
          name: "Y200e",
          url: "https://saleprice.in/collections/vivo-y200e-mobile-accessories-collection",
        },
        {
          name: "Y20g 2021",
          url: "https://saleprice.in/collections/vivo-y20g-2021-mobile-accessories-collection",
        },
        {
          name: "Y20i",
          url: "https://saleprice.in/collections/vivo-y20i-mobile-accessories-collection",
        },
        {
          name: "Y20s",
          url: "https://saleprice.in/collections/vivo-y20s-mobile-accessories-collection",
        },
        {
          name: "Y20t",
          url: "https://saleprice.in/collections/vivo-y20t-mobile-accessories-collection",
        },
        {
          name: "Y20t 1",
          url: "https://saleprice.in/collections/vivo-y20t-mobile-accessories-collection-1",
        },
        {
          name: "Y21",
          url: "https://saleprice.in/collections/vivo-y21-mobile-accessories-collection",
        },
        {
          name: "Y21 2021",
          url: "https://saleprice.in/collections/vivo-y21-2021-mobile-accessories-collection",
        },
        {
          name: "Y21e",
          url: "https://saleprice.in/collections/vivo-y21e-mobile-accessories-collection",
        },
        {
          name: "Y21l",
          url: "https://saleprice.in/collections/vivo-y21l-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y21t",
          url: "https://saleprice.in/collections/vivo-y21t-mobile-accessories-collection",
        },
        {
          name: "Y22",
          url: "https://saleprice.in/collections/vivo-y22-mobile-accessories-collection",
        },
        {
          name: "Y22s",
          url: "https://saleprice.in/collections/vivo-y22s-mobile-accessories-collection",
        },
        {
          name: "Y27 4g",
          url: "https://saleprice.in/collections/vivo-y27-4g-mobile-accessories-collection",
        },
        {
          name: "Y28 5g",
          url: "https://saleprice.in/collections/vivo-y28-5g-mobile-accessories-collection",
        },
        {
          name: "Y28s",
          url: "https://saleprice.in/collections/vivo-y28s-mobile-accessories-collection",
        },
        {
          name: "Y29",
          url: "https://saleprice.in/collections/vivo-y29-mobile-accessories-collection",
        },
        {
          name: "Y30",
          url: "https://saleprice.in/collections/vivo-y30-mobile-accessories-collection",
        },
        {
          name: "Y300 Pro",
          url: "https://saleprice.in/collections/vivo-y300-pro-mobile-accessories-collection",
        },
        {
          name: "Y31",
          url: "https://saleprice.in/collections/vivo-y31-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y33s",
          url: "https://saleprice.in/collections/vivo-y33s-mobile-accessories-collection",
        },
        {
          name: "Y33t",
          url: "https://saleprice.in/collections/vivo-y33t-mobile-accessories-collection",
        },
        {
          name: "Y35",
          url: "https://saleprice.in/collections/vivo-y35-mobile-accessories-collection",
        },
        {
          name: "Y36",
          url: "https://saleprice.in/collections/vivo-y36-mobile-accessories-collection",
        },
        {
          name: "Y36i",
          url: "https://saleprice.in/collections/vivo-y36i-mobile-accessories-collection",
        },
        {
          name: "Y37",
          url: "https://saleprice.in/collections/vivo-y37-mobile-accessories-collection",
        },
        {
          name: "Y38",
          url: "https://saleprice.in/collections/vivo-y38-mobile-accessories-collection",
        },
        {
          name: "Y39",
          url: "https://saleprice.in/collections/vivo-y39-mobile-accessories-collection",
        },
        {
          name: "Y400 Pro",
          url: "https://saleprice.in/collections/vivo-y400-pro-mobile-accessories-collection",
        },
        {
          name: "Y50",
          url: "https://saleprice.in/collections/vivo-y50-mobile-accessories-collection",
        },
        {
          name: "Y51 2020",
          url: "https://saleprice.in/collections/vivo-y51-2020-mobile-accessories-collection",
        },
        {
          name: "Y51a",
          url: "https://saleprice.in/collections/vivo-y51a-mobile-accessories-collection",
        },
        {
          name: "Y51l",
          url: "https://saleprice.in/collections/vivo-y51l-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y52s",
          url: "https://saleprice.in/collections/vivo-y52s-mobile-accessories-collection",
        },
        {
          name: "Y53",
          url: "https://saleprice.in/collections/vivo-y53-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y55 4g",
          url: "https://saleprice.in/collections/vivo-y55-4g-mobile-accessories-collection",
        },
        {
          name: "Y55 5g",
          url: "https://saleprice.in/collections/vivo-y55-5g-mobile-accessories-collection",
        },
        {
          name: "Y55l",
          url: "https://saleprice.in/collections/vivo-y55l-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y55s",
          url: "https://saleprice.in/collections/vivo-y55s-mobile-accessories-collection",
        },
        {
          name: "Y56 5g",
          url: "https://saleprice.in/collections/vivo-y56-5g-mobile-accessories-collection",
        },
        {
          name: "Y66",
          url: "https://saleprice.in/collections/vivo-y66-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y67",
          url: "https://saleprice.in/collections/vivo-y67-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y69",
          url: "https://saleprice.in/collections/vivo-y69-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y71",
          url: "https://saleprice.in/collections/vivo-y71-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y72 5g",
          url: "https://saleprice.in/collections/vivo-y72-5g-mobile-accessories-collection",
        },
        {
          name: "Y73",
          url: "https://saleprice.in/collections/vivo-y73-mobile-accessories-collection",
        },
        {
          name: "Y73 1",
          url: "https://saleprice.in/collections/vivo-y73-mobile-accessories-collection-1",
        },
        {
          name: "Y75 5g",
          url: "https://saleprice.in/collections/vivo-y75-5g-mobile-accessories-collection",
        },
        {
          name: "Y77 5g",
          url: "https://saleprice.in/collections/vivo-y77-5g-mobile-accessories-collection",
        },
        {
          name: "Y78 5g",
          url: "https://saleprice.in/collections/vivo-y78-5g-mobile-accessories-collection",
        },
        {
          name: "Y81",
          url: "https://saleprice.in/collections/vivo-y81-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y81i",
          url: "https://saleprice.in/collections/vivo-y81i-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y83",
          url: "https://saleprice.in/collections/vivo-y83-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y83 Pro",
          url: "https://saleprice.in/collections/vivo-y83-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y90",
          url: "https://saleprice.in/collections/vivo-y90-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y91",
          url: "https://saleprice.in/collections/vivo-y91-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y91i",
          url: "https://saleprice.in/collections/vivo-y91i-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y93",
          url: "https://saleprice.in/collections/vivo-y93-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y95",
          url: "https://saleprice.in/collections/vivo-y95-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Y97",
          url: "https://saleprice.in/collections/vivo-y97-mobile-accessories-collection",
        },
        {
          name: "Z1 Pro",
          url: "https://saleprice.in/collections/vivo-z1-pro-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
        {
          name: "Z1x",
          url: "https://saleprice.in/collections/vivo-z1x-back-cover-tempered-glass-and-other-mobile-accessories-collection",
        },
      ],
    };